/* TK Product Card overrides */
(function () {
  if (typeof customElements === 'undefined') return;

  /* Disable hover image swap (previewImage/resetImage + previewVariant/resetVariant)
     + override Tinker's updatePrice. Tinker `product-card.js#updatePrice` na ř.187
     hledá `querySelectorAll('product-price [ref="priceContainer"]')[1]` (druhý
     element — Tinker assumption pro layouts s 2 product-price), ale nativní TK
     karty mají jen jeden → bug: cena se na variant swap kartě nikdy nezmění.
     Override používá querySelector (= první) a innerHTML swap. */
  customElements.whenDefined('product-card').then(function () {
    var Proto = customElements.get('product-card').prototype;
    Proto.previewImage = function () {};
    Proto.resetImage = function () {};
    Proto.previewVariant = function () {};
    Proto.resetVariant = function () {};

    Proto.updatePrice = function (event) {
      try {
        var html = event && event.detail && event.detail.data && event.detail.data.html;
        if (!html) return;
        var priceContainer = this.querySelector('product-price [ref="priceContainer"]');
        var newPriceElement = html.querySelector('product-price [ref="priceContainer"]');
        if (newPriceElement && priceContainer) {
          priceContainer.innerHTML = newPriceElement.innerHTML;
        }
      } catch (e) { /* no-op */ }
    };
  });

  /* Fix variant image swap on disabled slideshows.
     Theme disables card slideshows (disabled="true") which prevents
     slideshow.select() from working. We observe hidden attr changes
     on variant slides and directly swap aria-hidden to show them. */
  function initVariantSwapFix() {
    document.querySelectorAll('product-card .card-gallery slideshow-component').forEach(function (ss) {
      var variantSlides = ss.querySelectorAll('slideshow-slide[variant-image]');
      if (variantSlides.length === 0) return;
      if (ss.dataset.tkVariantFix) return;
      ss.dataset.tkVariantFix = '1';

      var allSlides = ss.querySelectorAll('slideshow-slide');

      function syncSlides() {
        var activeVariant = null;
        variantSlides.forEach(function (vs) {
          if (!vs.hidden && !activeVariant) activeVariant = vs;
        });
        if (activeVariant) {
          allSlides.forEach(function (s) {
            s.setAttribute('aria-hidden', s === activeVariant ? 'false' : 'true');
          });
        } else {
          allSlides.forEach(function (s, i) {
            s.setAttribute('aria-hidden', i === 0 ? 'false' : 'true');
          });
        }
      }

      syncSlides();
      var observer = new MutationObserver(syncSlides);
      variantSlides.forEach(function (vs) {
        observer.observe(vs, { attributes: true, attributeFilter: ['hidden'] });
      });
    });
  }

  /* Variant-level sold-out badge byl odstraněn — matoucí když má produkt
     více variant a jedna z nich je sold out, evokovalo to že je celý produkt
     vyprodaný. Liquid template (product-card-badges.liquid) už správně
     zobrazuje "Vyprodáno" jen když product.available == false (všechny varianty). */
  function initBadgeUpdate() {}

  /* Pre-fetch dat karty (obrázek, ceny, badge, rating, sourozenci) přes section endpoint
     (sections/tk-variant-images.liquid → /products/{handle}?section_id=tk-variant-images).
     Globo runtime metafieldy nedodává, takže badge/rating/sourozence musíme dotáhnout takhle.
     (Název endpointu je historický — dřív servíroval `custom.variantimages` metafield,
     ten je od 2026-07-27 mrtvý; obrázek karty = product.featured_image.)

     Window-level cache by handle — survives Globo re-renders po filtraci, takže když
     uživatel vyfiltruje a pak otevře produkt který už byl jednou viditelný (cache hit),
     swatche/main image jsou instantní. */
  var tkImageDataCache = window.__tkImageDataCache || new Map();
  window.__tkImageDataCache = tkImageDataCache;

  /* Vrátí variant ID, kterou má karta zobrazit:
     1) data-tk-variant-synced (set Globo filter syncem — má prioritu při aktivním filtru)
     2) Globo is-selected swatch (Liquid render = první dostupná, nebo po user kliku)
     3) native checked swatch radio — GATED na card._tkInitialPreferApplied. Initial load
        má server-side checkutou první-available variantu, takže by tady přepadlo a
        preferVariantId by se nikdy nezohlednil. Po prvním swapu nastavujeme flag a
        checked radio teď reflektuje buď náš swap nebo user click (po Tinker morphi) →
        respektovat ho má prioritu nad preferVariantId aby nedošlo k ping-pongu.
     4) data-selected-variant-id (Globo initial render — server-side override už dal on-sale)
     5) preferVariantId z endpoint dat (první available + on-sale — pro native initial render,
        kde žádný z výše uvedených zdrojů neexistuje a defaultně by padl na první variantu
        bez ohledu na slevu)
     6) první klíč z dat */
  function getTargetVariantId(card, data) {
    var synced = card.getAttribute('data-tk-variant-synced');
    if (synced && data && data.v && data.v[synced]) return synced;
    var selSw = card.querySelector('.tk-card-swatch.is-selected');
    if (selSw && selSw.dataset.tkVariantId && data && data.v && data.v[selSw.dataset.tkVariantId]) {
      return selSw.dataset.tkVariantId;
    }
    if (card._tkInitialPreferApplied) {
      var nativeChecked = card.querySelector(
        'swatches-variant-picker-component input[type="radio"][name*="-swatch"]:checked[data-variant-id]'
      );
      if (nativeChecked && data && data.v && data.v[nativeChecked.dataset.variantId]) {
        return nativeChecked.dataset.variantId;
      }
    }
    var stored = card.getAttribute('data-selected-variant-id');
    if (stored && data && data.v && data.v[stored]) return stored;
    if (data && data.preferVariantId && data.v && data.v[data.preferVariantId]) {
      return data.preferVariantId;
    }
    if (data && data.v) {
      var k = Object.keys(data.v);
      if (k.length) return k[0];
    }
    return null;
  }

  /* Aktualizuje vizuální stav karty pro target variantu: posune is-selected
     na odpovídající swatch, swapne hlavní obrázek a cenu. Idempotentní —
     swap proběhne jen když se cíl liší od momentálně zobrazeného (sledováno
     přes data-tk-displayed-vid na kartě). */
  /* Flash-free image swap: přednačte nový obrázek do paměti a prohodí src až
     KDYŽ je dekódovaný → starý obrázek zůstane viditelný do poslední chvíle,
     žádná prázdná (bílá) fáze mezi src změnou a loadem. Bez tohohle Globo
     karty po filter-reloadu „probliknou bíle", protože naše injektáž přepíše
     img.src napřímo a <img> je během loadu prázdný. Pro cached obrázek swap proběhne okamžitě (bez flashe). */
  function tkSwapImgFlashFree(imgEl, newSrc) {
    if (!imgEl || !newSrc) return;
    var apply = function () {
      imgEl.removeAttribute('srcset');
      imgEl.src = newSrc;
    };
    var pre = new Image();
    var done = false;
    var swap = function () { if (done) return; done = true; apply(); };
    pre.onload = swap;
    pre.onerror = swap; // i při chybě swapni (lepší než držet starý / čekat věčně)
    pre.src = newSrc;
    if (pre.complete && pre.naturalWidth > 0) swap(); // už v cache
  }

  function renderTargetVariant(card, targetVid, variantData) {
    if (!targetVid || !variantData) return;

    /* Move is-selected to target swatch (jen pokud target swatch existuje —
       filtr může matchnout variantu bez color swatche, např. capacity). */
    var targetSwatch = card.querySelector('.tk-card-swatch[data-tk-variant-id="' + targetVid + '"]');
    if (targetSwatch && !targetSwatch.classList.contains('is-selected')) {
      card.querySelectorAll('.tk-card-swatch.is-selected').forEach(function (s) {
        s.classList.remove('is-selected');
      });
      targetSwatch.classList.add('is-selected');
    }

    var displayedVid = card.getAttribute('data-tk-displayed-vid');
    if (String(displayedVid) === String(targetVid)) return;

    /* Image swap — JEN pro karty bez native Tinker picker (= Globo).
       Native featured collection karty mají vícero slideshow-slide elementů
       (jeden per variant image) a swap řešíme níže přes card.previewVariant(mediaId)
       co posune slideshow na correct slide. Přepsání img.src na current active
       slide by korruptovalo OLD slide (po previewVariant by user navigací zpět
       viděl wrong image). */
    var hasNativePicker = !!card.querySelector('swatches-variant-picker-component');
    if (!hasNativePicker && variantData.imgs && variantData.imgs.length > 0) {
      var imgEl = card.querySelector('slideshow-slide[aria-hidden="false"] img.product-media__image')
               || card.querySelector('slideshow-slide:first-child img.product-media__image')
               || card.querySelector('img.product-media__image');
      if (imgEl) {
        var targetSrc = variantData.imgs[0];
        var currentSrc = imgEl.src || '';
        var currentBase = currentSrc.split('?')[0];
        var targetBase = targetSrc.split('?')[0];
        if (currentBase !== targetBase) {
          tkSwapImgFlashFree(imgEl, targetSrc);
        }
      }
    }

    /* Price swap — vždy přepiš na cenu target varianty. Pokud target == Liquid
       first variant, výsledek je vizuálně identický s rendered HTML.

       Native featured collection karty mají strukturu <product-price> > <div class="price-row">
       > <div ref="priceContainer">. Globo karty mají <product-price> > <div ref="priceContainer">
       přímo. Selektor `[ref="priceContainer"]` matchuje obě. NESMÍME zničit priceContainer
       element samotný — `ProductPrice.updatePrice` (product-price.js) ho po VariantUpdateEvent
       hledá přes querySelector a pokud je null/přepsaný, early-return → Tinker price refresh
       po user kliku selže. */
    if (variantData.price) {
      var priceContainer = card.querySelector('product-price [ref="priceContainer"]')
                        || card.querySelector('product-price > div')
                        || card.querySelector('product-price');
      if (priceContainer) {
        var labels = window.__tkPriceLabels || {};
        var lblReg = labels.regular || 'Běžná cena';
        var lblSale = labels.sale || 'Výprodejová cena';
        var badgeHtml = '';
        /* -X% pill INSIDE priceContainer (sjednoceno s Liquid emitem) — flex order 3 v CSS. */
        if (variantData.compareAtRaw && variantData.priceRaw && variantData.compareAtRaw > variantData.priceRaw) {
          var pct = Math.round((variantData.compareAtRaw - variantData.priceRaw) * 100 / variantData.compareAtRaw);
          badgeHtml = '<span class="price-discount-badge">-' + pct + '%</span>';
        }
        var newHtml;
        if (variantData.compareAt) {
          newHtml =
            '<span role="group"><span class="visually-hidden">' + lblSale + '&nbsp;</span><span class="price">' + variantData.price + '</span></span>' +
            '<span role="group"><span class="visually-hidden">' + lblReg + '&nbsp;</span><span class="compare-at-price">' + variantData.compareAt + '</span></span>' +
            badgeHtml;
        } else {
          newHtml = '<span class="price">' + variantData.price + '</span>';
        }
        priceContainer.innerHTML = newHtml;
      }
    }

    /* Native featured collection karty: dispatch change event na odpovídajícím
       radio swatchi. Tinker SwatchesVariantPickerComponent.variantChanged fetchne
       `section-rendering-product-card?variant=X` a morphne celou kartu (obrázek
       včetně přepnutí slideshow + cena + ring) v jednom shotu. Vlastní previewVariant
       /img.src swap nefunguje spolehlivě (slide-id mismatch, slideshow upgrade race),
       Tinker tu kompletně řeší rendering pipeline.

       Globo karty nemají swatches-variant-picker-component → tento blok no-op je. */
    var nativeRadio = card.querySelector(
      'swatches-variant-picker-component input[type="radio"][data-variant-id="' + targetVid + '"]'
    );
    if (nativeRadio && !nativeRadio.checked) {
      nativeRadio.checked = true;
      /* Wait for custom element upgrade (variantChanged listener attach), pak dispatch */
      var doDispatch = function () {
        if (!nativeRadio.checked) return;
        nativeRadio.dispatchEvent(new Event('change', { bubbles: true }));
      };
      if (window.customElements && window.customElements.whenDefined) {
        window.customElements
          .whenDefined('swatches-variant-picker-component')
          .then(doDispatch, function () {});
      } else {
        doDispatch();
      }
      /* Update productCardLink href tak aby klik šel na vybranou variantu (pre-morph;
         Tinker po morphi taky updatne) */
      var productLink = card.querySelector('.product-card__link');
      if (productLink && productLink.href) {
        try {
          var u = new URL(productLink.href, window.location.origin);
          u.searchParams.set('variant', targetVid);
          productLink.href = u.toString();
        } catch (e) { /* invalid URL */ }
      }
    }

    card.setAttribute('data-tk-displayed-vid', String(targetVid));
    /* Flag pro getTargetVariantId — po prvním swapu respektuj nativeChecked
       (= reflects user click po Tinker morphi). JS property survives DOM morph. */
    card._tkInitialPreferApplied = true;

    /* Kupon „S kódem“ pro novou variantu (cena s kódem se liší podle varianty) */
    if (card._tkVariantData) renderCardCoupon(card, card._tkVariantData, targetVid);
  }

  /* TK rating badge — stejný markup jako blocks/tk-rating-badge.liquid.
     SVG hvězdy, fill přes width-clip overlay. Card varianta = hvězdy +
     kompaktní meta „4,8 52×" (tučný průměr; rating_avg + rating_count_label
     z tk-card-data, lokalizované v Liquidu), bez click atributu (klik
     propadá na card link). */
  function buildRatingBadgeHtml(data) {
    var scale = data.rating_scale > 0 ? data.rating_scale : 5;
    var pct = Math.max(0, Math.min(100, ((data.rating || 0) / scale) * 100));
    var star = '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M31.547 12a.848.848 0 00-.677-.577l-9.427-1.376-4.224-8.532a.847.847 0 00-1.516 0l-4.218 8.534-9.427 1.355a.847.847 0 00-.467 1.467l6.823 6.664-1.612 9.375a.847.847 0 001.23.893l8.428-4.434 8.432 4.432a.847.847 0 001.229-.894l-1.615-9.373 6.822-6.665a.845.845 0 00.214-.869z"/></svg>';
    var stars = star + star + star + star + star;
    var metaHtml = '';
    if (data.rating_avg && data.rating_count_label) {
      var metaEl = document.createElement('span');
      metaEl.className = 'tk-rating-badge__text';
      var avgEl = document.createElement('strong');
      avgEl.className = 'tk-rating-badge__avg';
      avgEl.textContent = data.rating_avg;
      metaEl.appendChild(avgEl);
      metaEl.appendChild(document.createTextNode(' ' + data.rating_count_label));
      metaHtml = metaEl.outerHTML;
    }
    return '<div class="tk-rating-badge">'
      + '<span class="tk-rating-badge__stars" aria-hidden="true">'
      + '<span class="tk-rating-badge__row tk-rating-badge__row--bg">' + stars + '</span>'
      + '<span class="tk-rating-badge__row tk-rating-badge__row--fill" style="width: ' + pct.toFixed(1) + '%;">' + stars + '</span>'
      + '</span>'
      + metaHtml
      + '</div>';
  }

  /* Swatch skeleton placeholder (server-rendered v globo.filter.product.liquid pro
     split/metafield produkty) — odstraň jakmile dorazí data (real swatche je
     nahradí přes injectSiblingSwatches, nebo produkt swatche nemá → jen zmizí). */
  function removeSwatchSkeleton(card) {
    if (!card) return;
    var sk = card.querySelector('.tk-card-swatches--skeleton[data-tk-swatch-skeleton]');
    if (sk) sk.parentNode && sk.parentNode.removeChild(sk);
  }

  /* Ghost loading placeholder do swatch slotu — pro NEcachované produkty (mimo
     embed, >50), které se reálně tahají ze sítě (~300 ms). Shimmer kuličky se
     ukážou hned, applyVariantImages je pak nahradí reálnými swatchi (nebo
     removeSwatchSkeleton odstraní). U cachovaných (embed) ghost NEpřidáváme —
     ty injektnou instantně. Neduplikovat když už swatch container je
     (Globo variant swatche / dřív injektnuto). */
  function addSwatchGhost(card) {
    if (!card) return;
    if (card.querySelector('.tk-card-swatches')) return;
    var bottomRow = card.querySelector('.tk-card-bottom-row');
    var ghost = document.createElement('div');
    ghost.className = 'tk-card-swatches tk-card-swatches--skeleton';
    ghost.setAttribute('data-tk-swatch-skeleton', '');
    ghost.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < 3; i++) {
      var dot = document.createElement('span');
      dot.className = 'tk-card-swatch tk-card-swatch--skeleton';
      ghost.appendChild(dot);
    }
    var ghostAnchor = swatchAnchor(card) || bottomRow;
    if (ghostAnchor && ghostAnchor.parentNode) ghostAnchor.parentNode.insertBefore(ghost, ghostAnchor);
    else card.appendChild(ghost);
  }

  function applyVariantImages(card, data) {
    if (!data || !data.v) return;
    /* Skeleton splnil úkol (loading animace) — data jsou tu, ukážeme reálné swatche. */
    removeSwatchSkeleton(card);
    /* Stash data na card pro pozdější přístup z renderTargetVariant (variant swap) */
    card._tkVariantData = data;
    /* Cache labels v window pro performVariantSwap (click handler) */
    if (data.label_regular || data.label_sale) {
      window.__tkPriceLabels = window.__tkPriceLabels || {};
      if (data.label_regular) window.__tkPriceLabels.regular = data.label_regular;
      if (data.label_sale) window.__tkPriceLabels.sale = data.label_sale;
    }

    if (data.atc_labels) window.__tkAtcLabels = data.atc_labels;

    /* TK: badge pilulky (custom.badges) — Globo runtime metafieldy neexposuje, takže
       je renderujeme server-side v tk-card-data.liquid a injektujeme sem. */
    if (data.badges_html) {
      var tkBadgeBox = card.querySelector('.product-badges');
      /* Guard ignoruje servisní pilulku „Doprava zdarma" — je taky .tk-badge a
         dřív dokázala injekci zablokovat. Blokuje jen skutečná promo pilulka
         (wrapper .tk-badges i holé spany v server-renderované kartě).
         Injektované pilulky patří ZA freeship, ta drží 1. místo. */
      if (tkBadgeBox && !tkBadgeBox.querySelector('.tk-badge:not(.tk-badge--freeship)')) {
        var tkFsPill = tkBadgeBox.querySelector('.tk-badge--freeship');
        if (tkFsPill) tkFsPill.insertAdjacentHTML('afterend', data.badges_html);
        else tkBadgeBox.insertAdjacentHTML('afterbegin', data.badges_html);
      }
    }

    /* TK: očekávané naskladnění (custom.eta_date) — Globo runtime metafieldy nezná,
       server text „Není skladem" přepíšeme na „Očekáváme 21. 10." z tk-card-data.
       Jen u vyprodané karty, která ještě neukazuje jiného sourozence. */
    if (data.stock_eta) {
      var tkEtaBadge = card.querySelector('.tk-stock-badge--out');
      var tkEtaSib = card.querySelector('.tk-card-swatch--sibling.is-selected');
      if (tkEtaBadge && (!tkEtaSib || tkEtaSib.classList.contains('tk-card-swatch--soldout'))) {
        tkEtaBadge.textContent = data.stock_eta;
        tkEtaBadge.classList.add('tk-stock-badge--eta');
      }
    }

    var swatches = card.querySelectorAll('.tk-card-swatch[data-tk-swatch]');
    swatches.forEach(function (sw) {
      var vid = sw.dataset.tkVariantId;
      var v = data.v[vid];
      if (!v) return;
      /* Populate price + compare attrs (Globo runtime nedodává variant.compare_at_price) */
      if (v.price) sw.dataset.tkVariantPrice = v.price;
      if (v.compareAt) sw.dataset.tkVariantCompare = v.compareAt;
      /* Image swatch — replace shimmer placeholder s thumbnailem. Img má opacity:0
         dokud onload nepřidá .is-loaded → CSS pak fade-in + shimmer animace zmizí
         (`.tk-card-swatch:not(:has(img.is-loaded))` rule). */
      if (v.imgs && v.imgs.length > 0) {
        sw.dataset.tkVariantImage = v.imgs[0];
        var existingImg = sw.querySelector('img');
        if (!existingImg) {
          var img = document.createElement('img');
          img.alt = v.name || '';
          img.loading = 'lazy';
          img.addEventListener('load', function () { this.classList.add('is-loaded'); }, { once: true });
          img.addEventListener('error', function () { this.classList.add('is-loaded'); }, { once: true });
          /* TK 2026-08-22 perf: `sw` je 120px thumbnail pro 24px swatch box.
             `imgs[0]` je 800px obrazek KARTY — fallback pro data z drivejsi cache. */
          img.src = v.sw || v.imgs[0];
          /* Cached image — `complete` true a load event už nezafire */
          if (img.complete && img.naturalWidth > 0) img.classList.add('is-loaded');
          sw.appendChild(img);
        } else if (!existingImg.classList.contains('is-loaded')) {
          /* Server-rendered img (Liquid emit z variant.image) — pokud už loadnutý, mark */
          if (existingImg.complete && existingImg.naturalWidth > 0) {
            existingImg.classList.add('is-loaded');
          } else {
            existingImg.addEventListener('load', function () { this.classList.add('is-loaded'); }, { once: true });
            existingImg.addEventListener('error', function () { this.classList.add('is-loaded'); }, { once: true });
          }
        }
      }
    });

    /* Rating badge — Globo runtime metafields nedodává, takže injectneme až
       po fetchi sekce. TK SVG badge (rating data z tk-variant-images, stejný
       markup jako blocks/tk-rating-badge.liquid — žádná závislost na jdgm
       CSS/fontu), jen hvězdy bez textu. 0 recenzí = neinjektovat (prázdný
       slot drží .tk-card-rating min-height pro zarovnání karet).
       Fallback na jdgm badge_html pro starý section render (cache skew). */
    if (data.rating_count > 0 || (data.rating_count === undefined && data.badge_html)) {
      var rating = card.querySelector('.tk-card-rating');
      if (rating && !rating.dataset.tkBadgeFilled) {
        rating.innerHTML = data.rating_count !== undefined
          ? buildRatingBadgeHtml(data)
          : data.badge_html;
        rating.dataset.tkBadgeFilled = '1';
      }
    }

    /* TK 2026-07-28: automatická „Sleva" pilulka (z compare_at_price) zrušena —
       slevové štítky řešíme výhradně přes custom.badges (Akce / represents_sale),
       které sem přicházejí v data.badges_html. Případnou zbylou nativní Slevu
       (server render ze staré cache / jiné plochy) zhasneme. */
    var tkStaleSale = card.querySelector('.product-badges .product-badges__badge--sale');
    if (tkStaleSale) tkStaleSale.remove();

    /* Render to target variant — priorita: Globo filter sync > is-selected > Liquid first */
    var targetVid = getTargetVariantId(card, data);
    if (targetVid && data.v[targetVid]) {
      renderTargetVariant(card, targetVid, data.v[targetVid]);
    }

    /* Kupon „S kódem“: Globo karty ho ze serveru nemají, nativním ho srovná s variantou. */
    renderCardCoupon(card, data, targetVid);

    /* Barevné rodiny (split produkty) — injektni sourozenecké swatche. */
    injectSiblingSwatches(card, data);
  }

  /* Po fetchi/aplikaci dat ukáž swatches container — počká na load všech img
     thumbnailů (aby user neviděl color circles → image flash). Pokud žádné
     img (color-only fallback nebo fetch fail), ukáž okamžitě. */
  function showSwatchContainer(card) {
    var container = card.querySelector('.tk-card-swatches');
    if (!container || container.classList.contains('is-loaded')) return;
    var imgs = Array.from(container.querySelectorAll('img'));
    if (imgs.length === 0) {
      container.classList.add('is-loaded');
      return;
    }
    var pending = imgs.length;
    var done = function () { if (--pending <= 0) container.classList.add('is-loaded'); };
    /* Bezpečnostní timeout — kdyby load event nepřišel za 1.5s, ukaž stejně */
    setTimeout(function () {
      if (!container.classList.contains('is-loaded')) container.classList.add('is-loaded');
    }, 1500);
    imgs.forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) done();
      else {
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
      }
    });
  }

  /* ─────────────────────────────────────────────────────────────────────
     Discount pill na kartách — same princip jako PDP buybox pill.
     Render mezi swatches a bottom-row. Click flow:
       - add mode: AJAX add to cart + sessionStorage flag + nav /discount?redirect=current
       - choose mode: nav /discount?redirect=PDP (žádný add)
       - sold_out mode: nav /discount?redirect=PDP (žádný add)
     ───────────────────────────────────────────────────────────────────── */
  /* Pokud má karta viditelný color swatch (Globo / Tinker product-swatches /
     tk-mini-swatches), user může zvolit barvu rovnou na kartě → add mode
     i pro multi-option produkty (jinak quick-add renderuje --choose button
     protože options.size > 1 a my bychom redirektovali zbytečně na PDP). */
  function cardHasVisibleColorSwatches(card) {
    if (!card) return false;
    if (card.querySelector('.tk-card-swatch[data-tk-variant-id]')) return true;
    if (card.querySelector('.tk-mini-swatch[href*="variant="]')) return true;
    var ps = card.querySelector('product-swatches');
    if (ps && (ps.children.length > 0 || ps.querySelector('input, swatch-element, a, button'))) return true;
    return false;
  }

  function getCardAtcMode(card) {
    if (!card) return 'add';
    /* --notify = vyprodáno (odkaz na PDP s Rez „Hlídat dostupnost"); pořád
       sold_out režim → discount pill se nerenderuje (není co přidat do košíku). */
    /* `:not(.tk-atc-hidden)` — po překliku barvy zůstává server-rendered tlačítko
       v DOM jen schované (viz applySiblingAtc), takže by jinak diktovalo režim
       původní barvy. */
    if (card.querySelector('.tk-card-atc--sold-out, .tk-card-atc--notify, .tk-card-atc--ended')) return 'sold_out';
    if (card.querySelector('.quick-add__button[disabled]:not(.tk-atc-hidden), .quick-add__button--notify:not(.tk-atc-hidden), .quick-add__button--ended:not(.tk-atc-hidden)')) return 'sold_out';
    if (cardHasVisibleColorSwatches(card)) return 'add';
    if (card.querySelector('.tk-card-atc--choose, .quick-add__button--choose:not(.tk-atc-hidden)')) return 'choose';
    return 'add';
  }

  /* Resolve variant ID z karty napříč rendering systémy (Globo / native Tinker / tk-mini).
     Priority: nejdřív DYNAMICKY updatované zdroje (po user swatch kliku),
     pak server-side static fallbacky.

     **Native Tinker karty**: <quick-add-component> má hidden <input name="id">
     který Tinker product-form-component updatuje na swatch click. To je
     canonical source — overuj se nad data-tk-displayed-vid (Globo-only, na
     native kartách buď nepřítomný nebo stale po Tinker swatch click).

     **Globo karty**: data-tk-displayed-vid je nastavený v renderTargetVariant
     po user kliku na .tk-card-swatch. Žádný quick-add-component → fallback
     přes is-selected swatch / data-selected-variant-id / ATC button. */
  function resolveCardVariantId(card) {
    if (!card) return null;
    /* Native: Tinker updatuje hidden input okamžitě při swatch click */
    var hidden = card.querySelector('quick-add-component input[name="id"]');
    if (hidden && hidden.value && !hidden.hasAttribute('disabled')) return hidden.value;
    /* Globo: data-tk-displayed-vid set v JS renderTargetVariant */
    var v = card.getAttribute('data-tk-displayed-vid');
    if (v) return v;
    var sel = card.querySelector('.tk-card-swatch.is-selected[data-tk-variant-id]');
    if (sel) return sel.getAttribute('data-tk-variant-id');
    /* Server-side static fallbacks (won't reflect user swatch selection) */
    v = card.getAttribute('data-selected-variant-id');
    if (v) return v;
    var atc = card.querySelector('[data-tk-card-atc][data-variant-id]');
    if (atc) return atc.getAttribute('data-variant-id');
    var checked = card.querySelector('product-swatches input[type="radio"]:checked');
    if (checked && checked.value && /^\d+$/.test(checked.value)) return checked.value;
    var qBtn = card.querySelector('.quick-add__button[data-variant-id]');
    if (qBtn) return qBtn.getAttribute('data-variant-id');
    return null;
  }

  /* Produktový kupon „S kódem X · cena“ (markup snippets/tk-coupon.liquid, klik,
     kopírování a konec akce obsluhuje assets/tk-coupon.js). Nativní karty ho mají
     ze serveru (blocks/price.liquid), Globo karty a wishlist ho dostanou z dat
     karty: v[vid].cp = hotové HTML lístku pro variantu, siblings[].cp /
     data-tk-sibling-coupon = pro barvu. Prázdné = produkt/varianta kupon nemá. */
  /* Kam vložit swatche: nad pruh kuponu, když už v kartě je (kupon patří POD
     swatche, těsně nad spodní řádek s cenou), jinak nad spodní řádek. */
  function swatchAnchor(card) {
    var cp = card && card.querySelector('.tk-coupon--card');
    if (cp && cp.parentNode) return cp;
    return card ? card.querySelector('.tk-card-bottom-row') : null;
  }

  function applyCardCoupon(card, html) {
    if (!card) return;
    var cur = card.querySelector('.tk-coupon--card');
    html = (html || '').trim();
    if (!html) {
      if (cur) cur.remove();
      return;
    }
    if (cur && cur.outerHTML === html) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var el = tmp.firstElementChild;
    if (!el) return;
    if (cur) {
      cur.replaceWith(el);
      return;
    }
    /* Nad cenu (před spodní řádek karty), stejně jako server render v blocks/price.liquid */
    var bottomRow = card.querySelector('.tk-card-bottom-row');
    if (bottomRow && bottomRow.parentNode) {
      bottomRow.parentNode.insertBefore(el, bottomRow);
      return;
    }
    var sw = card.querySelector('.tk-card-swatches') || card.querySelector('product-swatches');
    if (sw && sw.parentNode) {
      sw.parentNode.insertBefore(el, sw.nextSibling);
      return;
    }
    var gc = card.querySelector('.group-block-content');
    if (gc) gc.appendChild(el);
  }

  function renderCardCoupon(card, data, targetVid) {
    if (!card || !data || !data.v) return;
    var vid = targetVid || getTargetVariantId(card, data);
    var v = vid && data.v[vid];
    /* Varianta z jiného produktu (po překliku barvy): kupon už srovnal sibling swap */
    if (!v) return;
    applyCardCoupon(card, v.cp || '');
  }

  /* API pro tk-coupon.js: jakou variantu karta právě ukazuje a jestli jde přidat rovnou */
  window.tkCard = {
    mode: function (card) { return getCardAtcMode(card); },
    variantId: function (card) { return resolveCardVariantId(card); },
  };

  /* Vrátí product handle z karty — primárně z data-tk-variant-url swatche,
     fallback na první card link (single-variant karty bez swatchů). */
  function getCardHandle(card) {
    if (!card) return null;
    var firstSw = card.querySelector('.tk-card-swatch[data-tk-swatch]');
    if (firstSw && firstSw.dataset.tkVariantUrl) {
      var m1 = firstSw.dataset.tkVariantUrl.match(/\/products\/([^?]+)/);
      if (m1) return m1[1];
    }
    var link = card.querySelector('a[href*="/products/"]');
    if (link) {
      var m2 = link.getAttribute('href').match(/\/products\/([^?#]+)/);
      if (m2) return m2[1];
    }
    return null;
  }

  /* sessionStorage cache pro tk-variant-images payloady — eliminuje network
     round-trip (~300+ ms) při opakovaných views v rámci session (paginace,
     návrat z PDP, další kolekce se stejnými produkty). TTL 15 min kvůli
     ceně/dostupnosti. Klíč locale-aware (CS/EN data se liší). */
  var TK_VI_TTL = 15 * 60 * 1000;
  function readViCache(key) {
    try {
      var raw = sessionStorage.getItem(key);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || !obj.ts || Date.now() - obj.ts > TK_VI_TTL) {
        sessionStorage.removeItem(key);
        return null;
      }
      return obj.d;
    } catch (e) { return null; }
  }
  function writeViCache(key, data) {
    try {
      sessionStorage.setItem(key, JSON.stringify({ ts: Date.now(), d: data }));
    } catch (e) { /* quota / private mode — ignore */ }
  }

  /* Embedded swatch data (snippets/tk-swatch-data-embed.liquid v collection/search
     stránce) → nahřej tkImageDataCache pro VŠECHNY produkty (až 50) ještě před
     prvním Globo re-renderem. Pak fetchVariantImagesOnce trefí cache → swatche se
     po sortu/filtru injektnou OKAMŽITĚ, žádné „naskakování" po ~0,5 s. Jednou. */
  var tkEmbedIngested = false;
  function ingestEmbeddedSwatchData() {
    if (tkEmbedIngested) return;
    var el = document.getElementById('tk-swatch-data-embed');
    if (!el) return;
    tkEmbedIngested = true;
    var map;
    try { map = JSON.parse(el.textContent.trim()); } catch (e) { return; }
    if (!map || typeof map !== 'object') return;
    var tkRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var tkCountry = (window.__tkCountry || (window.Shopify && window.Shopify.country) || '');
    Object.keys(map).forEach(function (handle) {
      var data = map[handle];
      if (!data) return;
      if (!tkImageDataCache.has(handle)) {
        tkImageDataCache.set(handle, Promise.resolve(data));
      }
      writeViCache('tk_vi:' + tkRoot + ':' + tkCountry + ':' + handle, data);
    });
  }

  function fetchVariantImagesOnce(card) {
    if (!card) return Promise.resolve();
    var handle = getCardHandle(card);
    if (!handle) return Promise.resolve();

    if (!tkImageDataCache.has(handle)) {
      /* Locale-aware fetch — bez Shopify.routes.root (např. /en/) by se sekce
         vyrenderovala v default (CS) locale → sourozenecké labely česky a m.url
         bez /en/ prefixu (po kliku redirect podle země na špatný market). */
      var tkRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var tkCountry = (window.__tkCountry || (window.Shopify && window.Shopify.country) || '');
      var cacheKey = 'tk_vi:' + tkRoot + ':' + tkCountry + ':' + handle;
      var cached = readViCache(cacheKey);
      if (cached) {
        tkImageDataCache.set(handle, Promise.resolve(cached));
      } else {
        var p = fetch(tkRoot + 'products/' + handle + '?section_id=tk-variant-images' + (tkCountry ? '&country=' + tkCountry : ''))
          .then(function (r) { return r.ok ? r.text() : null; })
          .then(function (html) {
            if (!html) return null;
            var div = document.createElement('div');
            div.innerHTML = html;
            var section = div.querySelector('.shopify-section');
            if (!section) return null;
            try {
              var data = JSON.parse(section.textContent.trim());
              if (data) writeViCache(cacheKey, data);
              return data;
            } catch (e) { return null; }
          })
          .catch(function () { return null; });
        tkImageDataCache.set(handle, p);
      }
    }

    return tkImageDataCache.get(handle).then(function (data) {
      if (data) applyVariantImages(card, data);
      /* Skeleton pryč i když data nedorazila (fetch fail / produkt bez swatchů) —
         ať loading kuličky nevisí navždy. (Při data != null ho už sundal
         applyVariantImages → removeSwatchSkeleton; tady jen pojistka.) */
      removeSwatchSkeleton(card);
      showSwatchContainer(card);
    });
  }

  /* Globo card swatches — pre-fetch via IntersectionObserver (cards scrolled
     into viewport fetch their card data + photo swatches),
     click swaps image/price/links in-card, click on already-selected
     swatch lets the link navigate to PDP. */
  var tkSwatchIO = null;
  function getSwatchIO() {
    if (tkSwatchIO) return tkSwatchIO;
    if (typeof IntersectionObserver === 'undefined') return null;
    tkSwatchIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          fetchVariantImagesOnce(entry.target);
          tkSwatchIO.unobserve(entry.target);
        }
      });
    }, { rootMargin: '200px' });
    return tkSwatchIO;
  }

  function initSwatchClicks() {
    /* Eager prefetch — fire fetch HNED pro každou kartu (no IO wait).
       Předtím IntersectionObserver čekal až karta vstoupí do viewportu
       (rootMargin 200 px), což i pro first card znamenalo extra microtask
       + fetch delay → user viděl flash obrázku cca 500-1500 ms po render.
       Eager: fetch starty
       paralelně hned, swap se stane ~100-300 ms po render (jen network).
       Browser otevře ~6 parallel connections, ale Map cache deduplikuje
       per-handle takže každý produkt fetchne max 1× per page load. */
    /* Eager pro VŠECHNY product-card (Globo + native featured collection +
       recommendations). Předtím scope-nutý jen na #gf-products → native karty
       (homepage featured) bez fetched dat = discount pill se nerendroval. */
    document.querySelectorAll('product-card.product-card').forEach(function (card) {
      if (card._tkImagesQueued) return;
      card._tkImagesQueued = true;
      fetchVariantImagesOnce(card);
    });

    document.querySelectorAll('.tk-card-swatch[data-tk-swatch]').forEach(function (sw) {
      if (sw.dataset.tkSwatchInit === '1') return;
      sw.dataset.tkSwatchInit = '1';

      sw.addEventListener('click', function (e) {
        if (sw.classList.contains('is-selected')) return; /* let it navigate */
        e.preventDefault();
        e.stopPropagation();

        var card = sw.closest('product-card.product-card') || sw.closest('.product-card');
        if (!card) return;

        var doSwap = function () { performVariantSwap(card, sw); };
        if (!sw.dataset.tkVariantImage || sw.dataset.tkVariantImage === '') {
          fetchVariantImagesOnce(card).then(doSwap);
        } else {
          doSwap();
        }
      });
    });

    /* Sourozenecké swatche (barevné rodiny) — document delegace + img fade-in. */
    initSiblingSwatchHandler();
  }

  function performVariantSwap(card, sw) {
        var newImg = sw.dataset.tkVariantImage;
        var newPrice = sw.dataset.tkVariantPrice;
        var newCompare = sw.dataset.tkVariantCompare;
        var newUrl = sw.dataset.tkVariantUrl;
        var newVariantId = sw.dataset.tkVariantId;

        /* Swap image — visible slide nebo first slide; remove srcset (browser uses src) */
        var imgEl = card.querySelector('slideshow-slide[aria-hidden="false"] img.product-media__image')
                 || card.querySelector('slideshow-slide:first-child img.product-media__image')
                 || card.querySelector('img.product-media__image');
        if (newImg && imgEl) {
          tkSwapImgFlashFree(imgEl, newImg);
        }

        /* Swap price (rebuild priceContainer innerHTML) */
        var priceContainer = card.querySelector('product-price > div')
                          || card.querySelector('product-price');
        if (priceContainer && newPrice) {
          if (newCompare && newCompare.trim() !== '') {
            var lblReg = (window.__tkPriceLabels && window.__tkPriceLabels.regular) || 'Běžná cena';
            var lblSale = (window.__tkPriceLabels && window.__tkPriceLabels.sale) || 'Výprodejová cena';
            /* -X% badge (jako renderTargetVariant / sibling swap) — bez něj badge po
               překliku na slevovou variantu zmizel. */
            var vpRaw = parseFloat(sw.dataset.tkVariantPriceRaw);
            var vcRaw = parseFloat(sw.dataset.tkVariantCompareRaw);
            var vBadge = '';
            if (vcRaw && vpRaw && vcRaw > vpRaw) {
              vBadge = '<span class="price-discount-badge">-' + Math.round((vcRaw - vpRaw) * 100 / vcRaw) + '%</span>';
            }
            priceContainer.innerHTML =
              '<span role="group"><span class="visually-hidden">' + lblSale + '&nbsp;</span><span class="price">' + newPrice + '</span></span>' +
              '<span role="group"><span class="visually-hidden">' + lblReg + '&nbsp;</span><span class="compare-at-price">' + newCompare + '</span></span>' +
              vBadge;
          } else {
            priceContainer.innerHTML = '<span class="price">' + newPrice + '</span>';
          }
        }

        /* TK 2026-07-28: horní „Sleva" badge se při překliku varianty NEPŘIDÁVÁ —
           slevový štítek je jen custom.badges (Akce). Badge pilulky jsou produktové
           (ne variantní), takže při variant swapu zůstávají beze změny. */

        /* Update všechny card-related links (overlay, gallery, title) na novou variant URL */
        if (newUrl) {
          card.querySelectorAll('a:not(.tk-card-swatch)').forEach(function (a) {
            a.href = newUrl;
          });
        }

        /* Update wishlist + compare data attrs aby ukládaly správnou variantu */
        var wb = card.querySelector('wishlist-button.tk-wishlist-btn');
        if (wb) {
          wb.setAttribute('data-variant-id', newVariantId || '');
          if (newUrl) wb.setAttribute('data-url', newUrl);
          if (newImg) wb.setAttribute('data-image', newImg);
          if (newPrice) wb.setAttribute('data-price', newPrice);
        }
        var cb = card.querySelector('compare-button.tk-compare-btn');
        if (cb) {
          cb.setAttribute('data-variant-id', newVariantId || '');
          if (newUrl) cb.setAttribute('data-url', newUrl);
          if (newImg) cb.setAttribute('data-image', newImg);
        }

        /* Wishlist + compare buttony cachují this.variantId v connectedCallback —
           setAttribute samo o sobě cache neaktualizuje. Dispatch tk:variant:update
           triggrne handleVariantUpdate() na buttonech (listener na product-card),
           která ID přepíše a updatuje is-active state.
           ⚠️ NE 'variant:update' — to je Horizonův VariantUpdateEvent vyžadující
           detail.data.html; bez něj padá product-card.js / product-form.js.
           Viz delší komentář u druhého dispatche v performSiblingSwap(). */
        var newVidNum = newVariantId ? parseInt(newVariantId, 10) : null;
        if (newVidNum) {
          card.dispatchEvent(new CustomEvent('tk:variant:update', {
            bubbles: true,
            detail: {
              resource: {
                id: newVidNum,
                title: sw.getAttribute('aria-label') || '',
                url: newUrl || ''
              }
            }
          }));
        }

    /* Toggle selected state */
    card.querySelectorAll('.tk-card-swatch.is-selected').forEach(function (s) {
      s.classList.remove('is-selected');
    });
    sw.classList.add('is-selected');
  }

  /* ─────────────────────────────────────────────────────────────────────
     Barevné rodiny (split produkty) — sourozenecké swatche na kartě.
     Data z tk-variant-images sekce (data.siblings) → injektneme do <product-card>;
     mega menu + search modal renderují swatche server-side (snippet tk-sibling-swatches).
     Klik na ne-selected swatch překlikne kartu NA MÍSTĚ (obrázek/cena/odkaz/titulek/ATC)
     na danou barvu (= jiný produkt). Klik na selected swatch necháme navigovat.
     Jeden swap engine (performSiblingSwap) napříč product-card / mega / search.
     ───────────────────────────────────────────────────────────────────── */
  function markSwatchImgLoaded(img) {
    if (!img) return;
    if (img.complete && img.naturalWidth > 0) { img.classList.add('is-loaded'); return; }
    img.addEventListener('load', function () { this.classList.add('is-loaded'); }, { once: true });
    img.addEventListener('error', function () { this.classList.add('is-loaded'); }, { once: true });
  }

  /* Přepíše viditelný titulek karty napříč rendering systémy (Globo h3 + text-block,
     native text-block, mega/search). Použito i pro lokalizaci current produktu —
     Globo runtime renderuje CZ titulek i na EN, sekce (locale-aware) dodá EN. */
  function setCardTitle(root, title) {
    if (!root || !title) return;
    var sels = ['.tk-mega-products__title', '.tk-mega__mini-product-title', '.resource-card__title',
                'a[ref="productTitleLink"] .text-block p', '.product-grid-view-zoom-out--details h3',
                '.group-block-content .text-block p'];
    var hit = false;
    sels.forEach(function (sel) {
      root.querySelectorAll(sel).forEach(function (el) {
        if (el.textContent.trim() !== title) el.textContent = title;
        hit = true;
      });
    });
    if (!hit) {
      var el = root.querySelector('.text-block p');
      if (el && el.textContent.trim() !== title) el.textContent = title;
    }
  }

  function injectSiblingSwatches(card, data) {
    if (!card || !data || !data.siblings || data.siblings.length < 2) return;
    if (card._tkSiblingsInjected) return;
    /* Server-side render (blocks/price.liquid → tk-sibling-swatches) už siblings
       vykreslil → neinjektovat znovu (jinak duplikát). Swap engine je sdílený. */
    if (card.querySelector('.tk-card-swatches--sibling')) { card._tkSiblingsInjected = true; return; }
    /* Nemíchat s variant swatchi (multi-variant produkt). Split produkty jsou
       single-variant bez variant swatchů → tady projdeme. */
    if (card.querySelector('.tk-card-swatch[data-tk-swatch]')) return;
    card._tkSiblingsInjected = true;

    var container = document.createElement('div');
    container.className = 'tk-card-swatches tk-card-swatches--sibling is-loaded';
    data.siblings.forEach(function (s) {
      if (!s || !s.vid) return;
      var sOnSale = s.available && s.compareAtRaw != null && s.priceRaw != null && s.compareAtRaw > s.priceRaw;
      var a = document.createElement('a');
      a.className = 'tk-card-swatch tk-card-swatch--sibling' + (s.current ? ' is-selected' : '') + (s.available ? '' : ' tk-card-swatch--soldout') + (sOnSale ? ' tk-card-swatch--has-sale' : '');
      a.href = s.url || '#';
      a.setAttribute('data-tk-sibling', '1');
      a.setAttribute('data-tk-variant-id', s.vid);
      a.setAttribute('data-tk-sibling-url', s.url || '');
      a.setAttribute('data-tk-sibling-image', s.image || '');
      a.setAttribute('data-tk-sibling-title', s.title || '');
      a.setAttribute('data-tk-sibling-price', s.price || '');
      a.setAttribute('data-tk-sibling-compare', s.compareAt || '');
      if (s.priceRaw != null) a.setAttribute('data-tk-sibling-price-raw', s.priceRaw);
      if (s.compareAtRaw != null) a.setAttribute('data-tk-sibling-compare-raw', s.compareAtRaw);
      a.setAttribute('data-tk-sibling-available', s.available ? 'true' : 'false');
      /* badge pilulky té barvy (custom.badges) — každý sourozenec je vlastní produkt */
      a.setAttribute('data-tk-sibling-badges', s.badgesHtml || '');
      if (s.stockLabel) a.setAttribute('data-tk-sibling-stock-label', s.stockLabel);
      a.setAttribute('data-tk-sibling-eta', s.eta ? '1' : '0');
      a.setAttribute('data-tk-sibling-free-ship', s.freeShip ? 'true' : 'false');
      if (s.atcMode) a.setAttribute('data-tk-sibling-atc-mode', s.atcMode);
      /* kupon té barvy (tk-coupon.liquid), prázdný = barva kupon nemá */
      a.setAttribute('data-tk-sibling-coupon', s.cp || '');
      if (s.productId) a.setAttribute('data-tk-sibling-product-id', s.productId);
      if (s.handle) a.setAttribute('data-tk-sibling-handle', s.handle);
      a.setAttribute('aria-label', s.label || '');
      a.setAttribute('title', s.label || '');
      if (s.image) {
        var img = document.createElement('img');
        img.alt = s.label || '';
        img.loading = 'lazy';
        img.src = s.image;
        markSwatchImgLoaded(img);
        a.appendChild(img);
      }
      if (sOnSale) {
        var saleBadge = document.createElement('span');
        saleBadge.className = 'tk-swatch-sale';
        saleBadge.setAttribute('aria-hidden', 'true');
        saleBadge.textContent = '%';
        a.appendChild(saleBadge);
      }
      container.appendChild(a);
    });

    /* Umístění: nad .tk-card-bottom-row (jako variant swatche), fallback do content. */
    var bottomRow = swatchAnchor(card);
    if (bottomRow && bottomRow.parentNode) {
      bottomRow.parentNode.insertBefore(container, bottomRow);
    } else {
      var content = card.querySelector('.group-block-content') || card.querySelector('.product-card__content') || card;
      content.appendChild(container);
    }

    /* Lokalizace titulku current produktu — Globo runtime renderuje CZ i na EN,
       sekce (locale-aware fetch) dodá EN title pro current → přepiš na initial renderu. */
    for (var ci = 0; ci < data.siblings.length; ci++) {
      var cs = data.siblings[ci];
      if (cs && cs.current && cs.title) { setCardTitle(card, cs.title); break; }
    }
  }

  /* Hlavní (produktový) obrázek kořene — ne swatch thumbnail. */
  function siblingMainImage(root) {
    var imgs = Array.prototype.slice.call(root.querySelectorAll('img'));
    for (var i = 0; i < imgs.length; i++) {
      if (!imgs[i].closest('.tk-card-swatch')) return imgs[i];
    }
    return null;
  }

  /* Přepíše badge pilulky (custom.badges) na kartě po překliku barvy.
     Sourozenci = samostatné produkty s vlastními badge, takže se overlay renderuje
     celý znovu (jinak by na všech barvách visely badge té první — např. „Poslední
     kusy" jedné varianty na všech čtyřech). `html` = výstup snippetu tk-badges
     pro danou barvu (může být prázdný = barva žádný badge nemá). */
  function applySiblingBadges(root, html, available) {
    if (!root) return;
    /* a) plná karta — rohový overlay .product-badges (drží i nativní Vyprodáno) */
    var box = root.querySelector('.product-badges');
    if (box) {
      box.querySelectorAll('.tk-badges, .tk-badge').forEach(function (n) { n.remove(); });
      if (html) box.insertAdjacentHTML('afterbegin', html);
      var soldOut = box.querySelector('.product-badges__badge--sold-out');
      if (soldOut && available) soldOut.remove();
      return;
    }
    /* b) mini karty (mega menu, mobile drawer, search) — vlastní overlay
       .tk-card-badges, který se server-side renderuje JEN pro produkt s badge →
       když chybí a nová barva badge má, vyrob ho vedle hlavního obrázku. */
    var mini = root.querySelector('.tk-card-badges');
    if (mini) { mini.innerHTML = html; return; }
    if (!html) return;
    var img = siblingMainImage(root);
    var host = img && img.parentNode;
    if (!host) return;
    mini = document.createElement('div');
    mini.className = 'tk-card-badges';
    mini.innerHTML = html;
    host.insertBefore(mini, img.nextSibling);
  }

  /* ATC tlačítko po překliku barvy. Sourozenec je vlastní produkt, takže se může
     lišit i REŽIM tlačítka (Do košíku / Hlídat dostupnost / Vybrat variantu /
     Prodej skončil) — bez rebuildu zůstalo u vyprodané barvy klikatelné „Do košíku"
     a naopak u skladové barvy odkaz „Hlídat dostupnost".
     Režim počítá server (snippets/tk-sibling-atc-mode.liquid), popisky chodí
     v tk-card-data jako atc_labels. */
  var TK_ATC_SVG_CART = '<svg class="tk-card-atc__icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>';
  var TK_ATC_SVG_CART_SM = TK_ATC_SVG_CART.replace('width="18" height="18"', 'width="14" height="14"');
  var TK_ATC_SVG_BELL = '<svg class="tk-card-atc__icon" width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/></svg>';
  var TK_ATC_SVG_CHECK = '<svg class="tk-card-atc__check" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';

  function tkAttrEscape(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;')
      .replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  /* Markup .tk-card-atc (Globo / tk-card-html karty) — zrcadlí větve
     `tk_atc_mode` v snippets/globo.filter.product.liquid. Globo karta nemá vlastní
     „ended" větev (doprodej řeší jako vyprodáno) → ended mapujeme na notify. */
  function buildCardAtc(mode, ctx) {
    var url = tkAttrEscape(ctx.url);
    if (mode === 'choose') {
      return '<a class="tk-card-atc tk-card-atc--choose" href="' + url + '" aria-label="' + tkAttrEscape(ctx.label) + '">' +
        TK_ATC_SVG_CART_SM + '<span class="tk-card-atc__label">' + tkAttrEscape(ctx.label) + '</span></a>';
    }
    if (mode === 'notify' || mode === 'ended') {
      return '<a class="tk-card-atc tk-card-atc--notify" href="' + url + '#tk-notify" data-tk-rez-card' +
        ' data-tk-rez-product-id="' + tkAttrEscape(ctx.productId) + '"' +
        ' data-tk-rez-variant-id="' + tkAttrEscape(ctx.vid) + '"' +
        ' data-tk-rez-product-name="' + tkAttrEscape(ctx.title) + '"' +
        ' data-tk-rez-product-url="' + url + '"' +
        ' aria-label="' + tkAttrEscape(ctx.label) + '">' +
        TK_ATC_SVG_BELL + '<span class="tk-card-atc__label">' + tkAttrEscape(ctx.label) + '</span></a>';
    }
    return '<button type="button" class="tk-card-atc tk-card-atc--add" data-tk-card-atc="1"' +
      ' data-product-id="' + tkAttrEscape(ctx.productId) + '"' +
      ' data-product-handle="' + tkAttrEscape(ctx.handle) + '"' +
      ' data-variant-id="' + tkAttrEscape(ctx.vid) + '"' +
      ' aria-label="' + tkAttrEscape(ctx.label) + '">' +
      TK_ATC_SVG_CART + '<span class="tk-card-atc__label">' + tkAttrEscape(ctx.label) + '</span>' + TK_ATC_SVG_CHECK + '</button>';
  }

  function applySiblingAtc(root, sw, available) {
    var labels = window.__tkAtcLabels;
    var mode = sw.getAttribute('data-tk-sibling-atc-mode');
    if (!mode) mode = available ? 'add' : 'notify';
    var ctx = {
      url: sw.getAttribute('data-tk-sibling-url') || '',
      vid: sw.getAttribute('data-tk-variant-id') || '',
      productId: sw.getAttribute('data-tk-sibling-product-id') || '',
      handle: sw.getAttribute('data-tk-sibling-handle') || '',
      title: sw.getAttribute('data-tk-sibling-title') || '',
      label: (labels && labels[mode]) || ''
    };

    /* a) Globo / tk-card-html karta — vlastní jednoduchý markup, přerenderujeme celý.
       Delegovaný click handler je na dokumentu (data-tk-card-atc), takže rebuild
       nic neodpojí. */
    var cardAtc = root.querySelector('.tk-card-atc');
    if (cardAtc) {
      if (!ctx.label) return; /* bez popisků (card data ještě nedorazila) radši nesahat */
      cardAtc.outerHTML = buildCardAtc(mode, ctx);
      return;
    }

    /* b) Native karta (Horizon quick-add). Server-rendered tlačítko NESMÍME přestavět
       ani jen zamknout:
         - je zadrátované přes ref/on:click uvnitř <add-to-cart-component> (rebuild
           utrhne vazbu),
         - `[disabled]` má v tk-product-card.css `display:none !important` → zamčené
           tlačítko z karty úplně ZMIZÍ (na homepage přesně tenhle případ).
       Řešení: originál jen schováme (inline `!important`, aby přebil CSS) a vedle něj
       držíme vlastní `[data-tk-atc-alt]` prvek ve správném režimu — `--add` jede přes
       delegovaný TK handler (`data-tk-card-atc`, stejný jako Globo karty), zbytek jsou
       plain odkazy/span. Když se barva vrátí do režimu, ve kterém je server-rendered
       originál, alt zahodíme a originál odkryjeme (Horizon vazba zůstala celou dobu
       nedotčená). */
    var qWrap = root.querySelector('quick-add-component');
    if (!qWrap) return;
    var canAdd = mode === 'add';
    var qInput = qWrap.querySelector('input[name="id"]');
    if (qInput) {
      if (canAdd) qInput.removeAttribute('disabled');
      else qInput.setAttribute('disabled', '');
    }
    var orig = qWrap.querySelector('.quick-add__button:not([data-tk-atc-alt])');
    var alt = qWrap.querySelector('[data-tk-atc-alt]');

    /* Bez popisků (card data ještě nedorazila) neumíme náhradu postavit — nechat být,
       ať radši zůstane původní tlačítko, než aby zmizelo. */
    if (!ctx.label) return;

    if (orig && tkQuickAddMode(orig) === mode) {
      orig.style.removeProperty('display');
      orig.classList.remove('tk-atc-hidden');
      if (alt) alt.remove();
      if (orig.tagName === 'A') tkRetargetNotifyLink(orig, ctx);
      return;
    }

    var html = buildQuickAddAlt(mode, ctx, orig);
    if (alt) {
      alt.outerHTML = html;
    } else if (orig) {
      orig.insertAdjacentHTML('afterend', html);
    } else {
      var form = qWrap.querySelector('form') || qWrap;
      form.insertAdjacentHTML('beforeend', html);
    }
    if (orig) {
      orig.style.setProperty('display', 'none', 'important');
      orig.classList.add('tk-atc-hidden');
    }
  }

  function tkQuickAddMode(el) {
    var c = el.classList;
    if (c.contains('quick-add__button--add')) return 'add';
    if (c.contains('quick-add__button--notify')) return 'notify';
    if (c.contains('quick-add__button--ended')) return 'ended';
    if (c.contains('quick-add__button--choose')) return 'choose';
    return null;
  }

  function tkRetargetNotifyLink(a, ctx) {
    a.href = ctx.url + (a.classList.contains('quick-add__button--notify') ? '#tk-notify' : '');
    if (!a.hasAttribute('data-tk-rez-card')) return;
    a.setAttribute('data-tk-rez-product-id', ctx.productId);
    a.setAttribute('data-tk-rez-variant-id', ctx.vid);
    a.setAttribute('data-tk-rez-product-name', ctx.title);
    a.setAttribute('data-tk-rez-product-handle', ctx.handle);
    a.setAttribute('data-tk-rez-product-url', ctx.url);
  }

  /* Náhradní quick-add tlačítko pro native kartu — třídy zrcadlí snippets/quick-add.liquid,
     aby platil existující skin z tk-product-card.css. Ikonu pro „add" klonujeme z originálu
     (inline_asset_content SVG v JS nemáme). */
  function buildQuickAddAlt(mode, ctx, orig) {
    var label = tkAttrEscape(ctx.label);
    var url = tkAttrEscape(ctx.url);
    var base = 'button quick-add__button';
    if (mode === 'notify' || mode === 'ended') {
      if (mode === 'ended') {
        return '<span class="' + base + ' quick-add__button--ended" data-tk-atc-alt data-tk-sale-ended aria-disabled="true">' +
          '<span class="add-to-cart-text"><span class="add-to-cart-text__content">' + label + '</span></span></span>';
      }
      return '<a class="' + base + ' quick-add__button--notify" data-tk-atc-alt href="' + url + '#tk-notify" data-tk-rez-card' +
        ' data-tk-rez-product-id="' + tkAttrEscape(ctx.productId) + '"' +
        ' data-tk-rez-variant-id="' + tkAttrEscape(ctx.vid) + '"' +
        ' data-tk-rez-product-name="' + tkAttrEscape(ctx.title) + '"' +
        ' data-tk-rez-product-handle="' + tkAttrEscape(ctx.handle) + '"' +
        ' data-tk-rez-product-url="' + url + '" aria-label="' + label + '">' +
        '<span class="add-to-cart-text"><span class="svg-wrapper quick-add__notify-icon">' +
        '<svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/></svg>' +
        '</span><span class="add-to-cart-text__content">' + label + '</span></span></a>';
    }
    if (mode === 'choose') {
      return '<a class="' + base + ' quick-add__button--choose" data-tk-atc-alt href="' + url + '" aria-label="' + label + '">' +
        '<span class="add-to-cart-text"><span class="svg-wrapper add-to-cart-icon"></span>' +
        '<span class="add-to-cart-text__content">' + label + '</span></span></a>';
    }
    var icon = '';
    if (orig) {
      var origIcon = orig.querySelector('.add-to-cart-icon');
      if (origIcon) icon = origIcon.outerHTML;
    }
    return '<button type="button" class="' + base + ' quick-add__button--add" data-tk-atc-alt data-tk-card-atc="1"' +
      ' data-product-id="' + tkAttrEscape(ctx.productId) + '"' +
      ' data-product-handle="' + tkAttrEscape(ctx.handle) + '"' +
      ' data-variant-id="' + tkAttrEscape(ctx.vid) + '" aria-label="' + label + '">' +
      '<span class="add-to-cart-text">' + icon +
      '<span class="add-to-cart-text__content">' + label + '</span></span></button>';
  }

  function performSiblingSwap(root, sw) {
    var newImg = sw.getAttribute('data-tk-sibling-image');
    var newPrice = sw.getAttribute('data-tk-sibling-price');
    var newCompare = sw.getAttribute('data-tk-sibling-compare');
    var newUrl = sw.getAttribute('data-tk-sibling-url');
    var newTitle = sw.getAttribute('data-tk-sibling-title');
    var newVid = sw.getAttribute('data-tk-variant-id');
    var newAvail = sw.getAttribute('data-tk-sibling-available') === 'true';

    /* Obrázek */
    var imgEl = root.querySelector('slideshow-slide[aria-hidden="false"] img.product-media__image')
             || root.querySelector('slideshow-slide:first-child img.product-media__image')
             || siblingMainImage(root);
    if (newImg && imgEl) { tkSwapImgFlashFree(imgEl, newImg); }

    /* Cena — product-card má <product-price>, mega/search mají prostý cenový node.
       resource-card (search) má holý <div ref="priceContainer"> bez <product-price>
       wrapperu → matchni i ten, aby swap přerenderoval cenu vč. compare + -X% badge. */
    var priceContainer = root.querySelector('product-price [ref="priceContainer"]')
                      || root.querySelector('[ref="priceContainer"]')
                      || root.querySelector('product-price > div')
                      || root.querySelector('product-price');
    if (priceContainer && newPrice) {
      var labels = window.__tkPriceLabels || {};
      var lblReg = labels.regular || 'Běžná cena';
      var lblSale = labels.sale || 'Výprodejová cena';
      if (newCompare && newCompare.trim() !== '') {
        /* -X% badge (jako renderTargetVariant) — bez něj badge po překliku na slevu mizí */
        var pRaw = parseFloat(sw.getAttribute('data-tk-sibling-price-raw'));
        var cRaw = parseFloat(sw.getAttribute('data-tk-sibling-compare-raw'));
        var badge = '';
        if (cRaw && pRaw && cRaw > pRaw) {
          badge = '<span class="price-discount-badge">-' + Math.round((cRaw - pRaw) * 100 / cRaw) + '%</span>';
        }
        priceContainer.innerHTML =
          '<span role="group"><span class="visually-hidden">' + lblSale + '&nbsp;</span><span class="price">' + newPrice + '</span></span>' +
          '<span role="group"><span class="visually-hidden">' + lblReg + '&nbsp;</span><span class="compare-at-price">' + newCompare + '</span></span>' +
          badge;
      } else {
        priceContainer.innerHTML = '<span class="price">' + newPrice + '</span>';
      }
    } else if (newPrice) {
      /* mega/mini/drawer prostý cenový node (snippet tk-mega-price). MUSÍ přerenderovat
         i strukturu slevy (přeškrtnutá cena + % badge) a toggle --sale modifier, jinak
         po překliku na slevu badge zmizí (a na furt, i při překliku tam a zpět —
         dřív se innerHTML přepsalo jen aktuální cenou). Cena z money-tk nese &nbsp;,
         takže innerHTML, ne textContent. */
      var simplePrice = root.querySelector('.tk-mega-products__price')
                     || root.querySelector('.tk-mega__mini-product-price')
                     || root.querySelector('.tk-mobile-drawer__product-price')
                     || root.querySelector('.resource-card__content .price')
                     || root.querySelector('.price');
      if (simplePrice) {
        /* základní (ne-sale) class — derive z prvního tokenu co není --sale ani tk-mega-price */
        var baseCls = '';
        simplePrice.classList.forEach(function (c) {
          if (!baseCls && c.indexOf('--sale') === -1 && c.indexOf('tk-mega-price') === -1) baseCls = c;
        });
        var spRaw = parseFloat(sw.getAttribute('data-tk-sibling-price-raw'));
        var scRaw = parseFloat(sw.getAttribute('data-tk-sibling-compare-raw'));
        if (newCompare && newCompare.trim() !== '' && scRaw && spRaw && scRaw > spRaw) {
          var spPct = Math.round((scRaw - spRaw) * 100 / scRaw);
          simplePrice.innerHTML =
            '<span class="tk-mega-price__current">' + newPrice + '</span>' +
            '<span class="tk-mega-price__compare">' + newCompare + '</span>' +
            (spPct > 0 ? '<span class="tk-mega-price__badge">-' + spPct + '%</span>' : '');
          if (baseCls) simplePrice.classList.add(baseCls + '--sale');
        } else {
          simplePrice.innerHTML = newPrice;
          if (baseCls) simplePrice.classList.remove(baseCls + '--sale');
        }
      }
    }

    /* Badge pilulky (custom.badges) vybrané barvy. Sourozenci jsou SAMOSTATNÉ
       produkty → každý má vlastní badge (Poslední kusy, Novinka, Akce…), takže
       po překliku musíme celý obsah badge overlaye přerenderovat, ne jen doplnit.
       Nativní „Sleva" se nepřidává vůbec (viz applyVariantImages). */
    applySiblingBadges(root, sw.getAttribute('data-tk-sibling-badges') || '', newAvail);

    /* Kupon „S kódem“ té barvy: jen karty (mega menu/search atribut nemají) */
    if (sw.hasAttribute('data-tk-sibling-coupon')) applyCardCoupon(root, sw.getAttribute('data-tk-sibling-coupon'));

    /* Stock badge nad cenou (Skladem / Není skladem) — taky per-produkt, jinak by
       u vyprodané barvy zůstalo viset „Skladem" té předchozí. */
    var stockBadge = root.querySelector('.tk-stock-badge');
    if (stockBadge) {
      var stockLabel = sw.getAttribute('data-tk-sibling-stock-label');
      if (stockLabel) stockBadge.textContent = stockLabel;
      stockBadge.classList.toggle('tk-stock-badge--out', !newAvail);
      /* „Očekáváme 21. 10." (custom.eta_date) — text nese stockLabel, tady jen barva */
      stockBadge.classList.toggle('tk-stock-badge--eta', !newAvail && sw.getAttribute('data-tk-sibling-eta') === '1');
    }
    var stockHost = root.querySelector('product-card[data-tk-available]') ||
                    (root.matches && root.matches('product-card[data-tk-available]') ? root : null);
    if (stockHost) stockHost.setAttribute('data-tk-available', newAvail ? 'true' : 'false');

    /* „Doprava zdarma" — sourozenec je vlastní produkt s vlastní cenou, takže badge
       může po překliku barvy naskočit i zmizet (levnější barva pod hranicí). */
    applyFreeShipBadge(root, sw.getAttribute('data-tk-sibling-free-ship') === 'true' && newAvail);

    /* Odkazy (kromě swatchů) */
    if (newUrl) {
      root.querySelectorAll('a:not([data-tk-sibling])').forEach(function (a) { a.href = newUrl; });
    }

    /* Titulek (sourozenci se liší barvou) */
    if (newTitle) setCardTitle(root, newTitle);

    /* ATC retarget + wishlist/compare přes variant:update.
       Pořadí: nejdřív hidden input / data-variant-id, pak applySiblingAtc — ta umí
       tlačítko i celé přestavět (jiný režim u jiné barvy) a musí běžet AŽ po přepisu
       odkazů výše, jinak by jí `a.href = newUrl` sebral #tk-notify. */
    var atc = root.querySelector('[data-tk-card-atc]');
    if (atc) {
      atc.setAttribute('data-variant-id', newVid || '');
      atc.setAttribute('data-tk-variant-available', newAvail ? 'true' : 'false');
    }
    var hiddenId = root.querySelector('quick-add-component input[name="id"]');
    if (hiddenId && newVid) hiddenId.value = newVid;
    applySiblingAtc(root, sw, newAvail);

    var newVidNum = newVid ? parseInt(newVid, 10) : null;
    if (newVidNum) {
      /* TK 2026-07-27: dřív se posílal 'variant:update'. To je ale Horizonův
         VariantUpdateEvent (assets/events.js), jehož kontrakt vyžaduje
         detail.data.html (Document z re-renderu sekce). My tu žádné nové HTML
         nemáme — swap děláme lokálně — takže posluchači Horizonu padali:
           product-card.js #isUnavailableVariantSelected → data.html
           product-form.js  #onVariantUpdate            → data.newProduct
         Vlastní název proto, aby se TK swap nevydával za Horizonův event.
         Poslouchají ho tk-wishlist.js a tk-compare.js. */
      root.dispatchEvent(new CustomEvent('tk:variant:update', {
        bubbles: true,
        detail: { resource: { id: newVidNum, title: sw.getAttribute('aria-label') || '', url: newUrl || '' } }
      }));
    }

    /* Selected stav (jen mezi sourozeneckými swatchy) */
    root.querySelectorAll('.tk-card-swatch--sibling.is-selected').forEach(function (s) { s.classList.remove('is-selected'); });
    sw.classList.add('is-selected');
  }

  /* Document-level delegace — pokrývá injektnuté (product-card) i server-rendered
     (mega/search) sourozenecké swatche. Registruj 1×; re-mark img.is-loaded při
     opakovaném volání (mega/search re-render). */
  function initSiblingSwatchHandler() {
    document.querySelectorAll('.tk-card-swatch--sibling img:not(.is-loaded)').forEach(markSwatchImgLoaded);
    if (window.__tkSiblingSwatchInit) return;
    window.__tkSiblingSwatchInit = true;
    document.addEventListener('click', function (e) {
      var sw = e.target.closest('[data-tk-sibling]');
      if (!sw) return;
      if (sw.classList.contains('is-selected')) return; /* selected → navigovat */
      e.preventDefault();
      e.stopPropagation();
      var root = sw.closest('product-card.product-card') || sw.closest('.product-card')
              || sw.closest('.tk-mega-products__card') || sw.closest('.tk-mega__mini-product')
              || sw.closest('[data-tk-search-card]') || sw.closest('.resource-card');
      if (root) performSiblingSwap(root, sw);
    }, true);
  }

  /* ─────────────────────────────────────────────────────────────────────
     Hover preview barevných swatchů na product-card (Globo + native featured
     + PDP recommendations). Najetí myší na swatch přepne kartu (obrázek/cena/
     titulek/odkaz/ATC) na danou barvu — bez kliku. Sjetí myši ze swatch skupiny
     vrátí kartu na původní (defaultní) barvu. Klik na swatch nech navigovat na
     danou barvu (po hoveru je swatch už is-selected → existující click handlery
     propustí anchor navigaci).

     Jen na zařízeních s hoverem ('(hover: hover)') — na dotyku by mouseover/out
     emulace + sticky stav rozbily UX; tam click handlery drží původní chování.

     Reuse performVariantSwap / performSiblingSwap (battle-tested): preview = plný
     swap na hover, revert = plný swap zpět na default swatch. group._tkShown brání
     opakovanému swapu na tutéž barvu; group._tkHoverDefault drží barvu k revertu
     (zachycena z .is-selected při prvním hoveru — klik naviguje pryč → reload →
     default se resetuje sám). Scope = stejné roots jako klik-handler
     (product-card / mega / search resource-card) → swatche se chovají všude
     stejně jako na featured collections. */
  function tkHoverSwap(card, sw) {
    if (sw.matches('[data-tk-sibling]')) performSiblingSwap(card, sw);
    else performVariantSwap(card, sw);
  }

  /* Root karty pro swatch swap — shodné s initSiblingSwatchHandler (klik),
     aby hover preview fungoval i v search modalu / mega menu, ne jen na
     product-card (featured collections). */
  function swatchHoverRoot(el) {
    return el.closest('product-card.product-card') || el.closest('.product-card')
        || el.closest('.tk-mega-products__card') || el.closest('.tk-mega__mini-product')
        || el.closest('[data-tk-search-card]') || el.closest('.resource-card');
  }

  function initSwatchHover() {
    if (window.__tkSwatchHoverInit) return;
    if (!(window.matchMedia && window.matchMedia('(hover: hover)').matches)) return;
    window.__tkSwatchHoverInit = true;

    var SW_SEL = '.tk-card-swatch[data-tk-swatch], .tk-card-swatch--sibling[data-tk-sibling]';

    document.addEventListener('mouseover', function (e) {
      if (!e.target || !e.target.closest) return;
      var sw = e.target.closest(SW_SEL);
      if (!sw) return;
      var group = sw.closest('.tk-card-swatches');
      if (!group) return;
      var card = swatchHoverRoot(group);
      if (!card) return;
      if (group._tkShown === sw) return;
      if (!group._tkHoverDefault) {
        group._tkHoverDefault = group.querySelector('.tk-card-swatch.is-selected')
                             || group.querySelector('.tk-card-swatch');
      }
      group._tkShown = sw;
      tkHoverSwap(card, sw);
    });

    document.addEventListener('mouseout', function (e) {
      if (!e.target || !e.target.closest) return;
      var group = e.target.closest('.tk-card-swatches');
      if (!group || !group._tkShown) return;
      /* Přesun uvnitř téže skupiny (swatch→swatch / mezera) — neřešit revert. */
      var to = e.relatedTarget;
      if (to && group.contains(to)) return;
      var card = swatchHoverRoot(group);
      if (!card) return;
      var def = group._tkHoverDefault;
      group._tkShown = null;
      if (def) tkHoverSwap(card, def);
    });
  }

  /* Vystaveno pro tk-globo-filter.js: po aplikaci filtru zavolá Globo sync
     applyCardVariantId, ten po updatu URL/data-attrs zavolá tohle, abychom
     dorenderovali kartu na vyfiltrovanou variantu (image, swatch, cena).
     Pokud data ještě v cache nejsou, fetch je vyžádá a po appendu se aplikuje
     automaticky přes applyVariantImages → renderTargetVariant. */
  window.TKReapplyCardVariant = function (card) {
    if (!card) return;
    var handle = getCardHandle(card);
    if (!handle) return;
    if (tkImageDataCache.has(handle)) {
      tkImageDataCache.get(handle).then(function (data) {
        if (data) applyVariantImages(card, data);
      });
    } else {
      fetchVariantImagesOnce(card);
    }
  };

  /* ATC button on Globo cards.
     Dispatchne cart:add:initiate (cart-drawer.js otevře drawer, cart-icon.js
     bumpne bubble optimistic), pak fetch /cart/add.js se sections.
     Po response dispatchne cart:update (CartAddEvent.eventName) — component-cart-items
     to zachytí a zmorphne cart-items sekci. Error path → cart:add:revert.

     Tracking variant id priority (currently displayed/selected on card):
       1) .tk-card-swatch.is-selected → data-tk-variant-id (po user kliku
          nebo Globo filter sync přes applyCardVariantId).
       2) <product-card> data-tk-displayed-vid (po prvním renderTargetVariant).
       3) Button vlastní data-variant-id (server-side init).
       4) <product-card> data-selected-variant-id (Liquid fallback). */
  function resolveAtcVariant(card, btn) {
    var selSw = card.querySelector('.tk-card-swatch.is-selected');
    var vid = null;
    var available = null;
    if (selSw) {
      vid = selSw.getAttribute('data-tk-variant-id');
      var availAttr = selSw.getAttribute('data-tk-variant-available');
      if (availAttr === 'false') available = false;
      else if (availAttr === 'true') available = true;
    }
    if (!vid) vid = card.getAttribute('data-tk-displayed-vid');
    if (!vid) vid = btn.getAttribute('data-variant-id');
    if (!vid) vid = card.getAttribute('data-selected-variant-id');
    return { vid: vid, available: available };
  }

  function showAtcToast(msg) {
    /* Reuse .quick-add-toast styling (z snippets/quick-add.liquid stylesheet). */
    var old = document.querySelector('.quick-add-toast[data-tk-atc-toast]');
    if (old) old.remove();
    var t = document.createElement('div');
    t.className = 'quick-add-toast';
    t.setAttribute('data-tk-atc-toast', '1');
    t.setAttribute('role', 'status');
    t.setAttribute('aria-live', 'polite');
    t.innerHTML = '<span class="quick-add-toast__icon" aria-hidden="true">' +
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
      '<circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg></span>' +
      '<span class="quick-add-toast__text"></span>';
    t.querySelector('.quick-add-toast__text').textContent = msg;
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('quick-add-toast--visible'); });
    setTimeout(function () {
      t.classList.remove('quick-add-toast--visible');
      setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 350);
    }, 3200);
  }

  function getCartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      var sid = el.getAttribute('data-section-id');
      if (sid && ids.indexOf(sid) === -1) ids.push(sid);
    });
    return ids;
  }

  function handleAtcClick(btn) {
    if (btn.disabled || btn.dataset.tkAtcLoading === '1') return;
    /* Karta v mega menu (snippets/tk-mega-card.liquid) nemá <product-card> */
    var card = btn.closest('product-card') || btn.closest('.tk-mega-products__card');
    if (!card) return;

    var resolved = resolveAtcVariant(card, btn);
    var variantId = resolved.vid;
    if (!variantId) return;
    if (resolved.available === false) {
      showAtcToast(btn.getAttribute('data-tk-soldout-text') || 'Tato varianta je vyprodaná');
      return;
    }

    btn.dataset.tkAtcLoading = '1';
    btn.classList.add('is-loading');

    var qty = 1;
    var productId = btn.getAttribute('data-product-id') || '';

    /* Optimistic: drawer auto-opens, cart bubble bumps */
    btn.dispatchEvent(new CustomEvent('cart:add:initiate', {
      bubbles: true,
      composed: true,
      detail: { quantity: qty },
    }));

    var formData = new FormData();
    formData.append('id', String(variantId));
    formData.append('quantity', String(qty));
    var sectionIds = getCartSectionIds();
    if (sectionIds.length) formData.append('sections', sectionIds.join(','));

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    })
      .then(function (r) {
        return r.json().then(function (body) { return { ok: r.ok, body: body }; });
      })
      .then(function (res) {
        btn.dataset.tkAtcLoading = '';
        btn.classList.remove('is-loading');

        if (!res.ok || (res.body && res.body.status)) {
          /* Revert optimistic bubble + drawer loading bar */
          btn.dispatchEvent(new CustomEvent('cart:add:revert', {
            bubbles: true,
            composed: true,
            detail: { quantity: qty },
          }));
          /* Notify cart-icon so didError path skips render */
          btn.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            composed: true,
            detail: {
              resource: {}, sourceId: card.id || '',
              data: { didError: true, source: 'tk-card-atc', itemCount: qty, productId: productId },
            },
          }));
          var msg = (res.body && (res.body.description || res.body.message)) || ((window.__tkLabels && window.__tkLabels.addToCartError) || 'Chyba při přidávání do košíku');
          showAtcToast(msg);
          return;
        }

        var sections = (res.body && typeof res.body.sections === 'object' && res.body.sections) || {};

        /* CartAddEvent shape: detail.data.sections drives morph in component-cart-items.
           source: 'product-form-component' → cart-icon drains the optimistic bump
           (jinak by SET místo ADD count → resetnul by se na 1). */
        btn.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          composed: true,
          detail: {
            resource: {}, sourceId: card.id || '',
            data: {
              sections: sections,
              source: 'product-form-component',
              itemCount: qty,
              productId: productId,
            },
          },
        }));

        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 1800);
      })
      .catch(function (err) {
        btn.dataset.tkAtcLoading = '';
        btn.classList.remove('is-loading');
        btn.dispatchEvent(new CustomEvent('cart:add:revert', {
          bubbles: true,
          composed: true,
          detail: { quantity: qty },
        }));
        btn.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          composed: true,
          detail: {
            resource: {}, sourceId: card.id || '',
            data: { didError: true, source: 'tk-card-atc', itemCount: qty, productId: productId },
          },
        }));
        showAtcToast(((window.__tkLabels && window.__tkLabels.addToCartError) || 'Chyba při přidávání do košíku'));
        if (window.console) console.error('[tk-card-atc] add failed', err);
      });
  }

  function initAtcClicks() {
    if (window.__tkCardAtcInit) return;
    window.__tkCardAtcInit = true;
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var btn = t.closest('[data-tk-card-atc]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      handleAtcClick(btn);
    }, true);
  }

  /* Native Tinker quick-add button má parallelní `.add-to-cart-text--added` span
     pro success state (s "Přidáno" textem + checkmark). Snippet stylesheet
     (snippets/add-to-cart-button.liquid + snippets/quick-add.liquid {% stylesheet %})
     se v některých kontextech loaduje (proti CLAUDE.md note) a může způsobit že
     ten span je vidět paralelně s hlavním "Vyprodáno"/"Do košíku" textem — uživatel
     vidí "VyprodánoVyprodáno" nebo "Do košíkuPřidáno" duplikát uvnitř buttonu.
     Pro sold-out buttons (disabled) success animation stejně nikdy nepojede
     (button se neclickne), takže span úplně odstraním z DOMu. Pro available
     buttons span zachovám (potřeba pro atc-added success animation Tinker stack). */
  function stripSoldOutAddedSpan() {
    document.querySelectorAll('.quick-add__button[disabled] .add-to-cart-text--added').forEach(function (el) {
      el.remove();
    });
  }

  /* „Doprava zdarma" — servisní pilulka v rohovém badge overlayi (od 2026-09-03
     zase, user: „zas jako jednu z badge"). Server ji rendruje v
     product-card-badges.liquid (native karty, taky jako první); tady se přidává/odebírá pro Globo
     a wishlist karty (Globo runtime nemá settings ani metafieldy), po překliku
     sourozenecké barvy (jiná cena → jiný stav) a jako fallback na plochách, kde
     overlay projde bez ní. Label bere z data-tk-free-ship-label na
     <product-card>, s CS fallbackem. */
  function freeShipLabel(root) {
    var host = (root && root.closest && root.closest('product-card')) ||
               (root && root.querySelector && root.querySelector('product-card'));
    var lbl = host && host.getAttribute('data-tk-free-ship-label');
    if (lbl) return lbl;
    var any = document.querySelector('[data-tk-free-ship-label]');
    return (any && any.getAttribute('data-tk-free-ship-label')) || 'Doprava zdarma';
  }

  function applyFreeShipBadge(root, show) {
    if (!root) return;
    var existing = root.querySelector('.tk-badge--freeship');
    if (!show) {
      if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
      return;
    }
    if (existing) return;
    var overlay = root.querySelector('.product-badges');
    if (!overlay) return;
    var badge = document.createElement('span');
    badge.className = 'tk-badge tk-badge--freeship';
    badge.textContent = freeShipLabel(root);
    /* VŽDY první pilulka v overlayi (user 2026-09-03: „doprava zdarma badge všude
       na 1. místo") — nad promo badge i nad „Vyprodáno". */
    overlay.insertBefore(badge, overlay.firstChild);
  }

  /* Doplnění pilulky na kartách, kde ji server nevyrenderoval — hlavně GLOBO karty
     (kolekce) a wishlist. Rozhoduje se tady, protože Globo runtime nemá `settings`,
     takže hranici do Liquidu šablony nedostaneme; chodí přes window.__tkFsThreshold
     z layout/theme.liquid (v MINORITNÍCH jednotkách, jako všude v theme).

     🔴 `data-tk-price` je ale v MAJOR jednotkách (419 = 419 Kč) — Globo runtime
     `product_price` takhle vrací a jeho `| money` s tím počítá. Server-side kopie
     karty (sections/tk-card-html.liquid) proto v generátoru dělí stem, aby atribut
     znamenal totéž. Tady se násobí zpátky na minoritní.
     Native karty mají `data-tk-free-ship` spočítané pravým Liquidem — ten má přednost. */
  function injectFreeShipBadges() {
    var th = Number(window.__tkFsThreshold || 0);
    document.querySelectorAll('product-card').forEach(function (card) {
      if (card.querySelector('.tk-badge--freeship')) return;
      /* Jen karty s badge overlayem — mini karty (mega menu, drawer, search) ho nemají. */
      if (!card.querySelector('.product-badges')) return;
      var available = card.getAttribute('data-tk-available') !== 'false';
      var show;
      var flag = card.getAttribute('data-tk-free-ship');
      if (flag === 'true' || flag === 'false') {
        show = flag === 'true';
      } else {
        var major = parseFloat(card.getAttribute('data-tk-price'));
        var minor = Math.round(major * 100);
        show = th > 0 && !isNaN(major) && minor >= th;
      }
      applyFreeShipBadge(card, show && available);
    });
  }

  /* Stock badge — pro každou kartu malý indikátor nad názvem: zelený "Skladem" když
     `data-tk-available="true"`, červený "Není skladem" když "false". Label text + barva
     se odvozují z Liquid data attrů (data-tk-available + data-tk-stock-label) emitovaných
     v product-card.liquid (native) + globo.filter.product.liquid (Globo). Idempotent přes
     data-tk-stock-injected flag. */
  function injectStockBadge() {
    document.querySelectorAll('product-card[data-tk-available]').forEach(function (card) {
      if (card.getAttribute('data-tk-stock-injected') === '1') return;
      /* Server-side render badge (Globo + native featured cards) — pokud už existuje
         v DOM, jen flagni a skipni. Eliminuje 1s flash po refreshi. */
      if (card.querySelector('.tk-stock-badge')) {
        card.setAttribute('data-tk-stock-injected', '1');
        return;
      }
      var available = card.getAttribute('data-tk-available') === 'true';
      var label = card.getAttribute('data-tk-stock-label');
      if (!label) return;
      var container = card.querySelector('.group-block-content');
      if (!container) return;
      var badge = document.createElement('span');
      badge.className = 'tk-stock-badge' + (available ? '' : ' tk-stock-badge--out');
      badge.setAttribute('aria-hidden', 'true');
      badge.textContent = label;
      /* Insert před cenu (badge nad price). priceEl může být přímý child .group-block-content
         (původní layout) nebo uvnitř .tk-card-bottom-row__left (po Liquid restrukturalizaci
         pro ATC v price row) — proto insertBefore na priceEl.parentNode, ne na container. */
      var priceEl = container.querySelector('product-price');
      if (priceEl && priceEl.parentNode) {
        priceEl.parentNode.insertBefore(badge, priceEl);
      } else {
        container.appendChild(badge);
      }
      /* „Doprava zdarma" (overlay pilulka) se řeší v injectFreeShipBadges(). */
      card.setAttribute('data-tk-stock-injected', '1');
    });
  }

  /* Přesun ATC tlačítka z .card-gallery do bottom-row (vedle ceny). Pro native karty
     (featured collection) je quick-add-component child .card-gallery; pro Globo karty
     emituje Liquid .tk-card-bottom-row už přímo (skip wrap), jen JS si pohlídá pohyb
     stock-badge dovnitř left col. Idempotent přes data-tk-atc-relocated flag. */
  function relocateAtcButton() {
    document.querySelectorAll('product-card').forEach(function (card) {
      if (card.getAttribute('data-tk-atc-relocated') === '1') return;

      var priceEl = card.querySelector('product-price');
      if (!priceEl) return;

      var existingRow = card.querySelector('.tk-card-bottom-row');

      if (!existingRow) {
        var row = document.createElement('div');
        row.className = 'tk-card-bottom-row';
        var leftCol = document.createElement('div');
        leftCol.className = 'tk-card-bottom-row__left';
        var rightCol = document.createElement('div');
        rightCol.className = 'tk-card-bottom-row__right';
        row.appendChild(leftCol);
        row.appendChild(rightCol);

        var parent = priceEl.parentNode;
        parent.insertBefore(row, priceEl);
        var prev = row.previousElementSibling;
        while (prev && prev.classList && prev.classList.contains('tk-stock-badge')) {
          var stale = prev;
          prev = prev.previousElementSibling;
          leftCol.appendChild(stale);
        }
        leftCol.appendChild(priceEl);
        existingRow = row;
      }

      var rightTarget = existingRow.querySelector('.tk-card-bottom-row__right');
      if (!rightTarget) return;

      /* Quick-add je teď server-rendrovaný přímo v __right (blocks/price.liquid).
         Pokud tam JE → odstraň případnou galerie-kopii (deploy lag / gate ještě
         nenaběhl), jinak by se po data-tk-atc-relocated odkryla jako 2. viditelné
         ATC přes obrázek. Pokud v __right NENÍ (PDP recommendations, kde price
         bottom-row nestaví) → přesuň galerie quick-add do __right jako dřív. */
      if (rightTarget.querySelector('quick-add-component')) {
        card.querySelectorAll('.card-gallery quick-add-component').forEach(function (q) {
          if (q.parentNode) q.parentNode.removeChild(q);
        });
      } else {
        var quickAdd = card.querySelector('quick-add-component');
        if (quickAdd && !rightTarget.contains(quickAdd)) {
          rightTarget.appendChild(quickAdd);
        }
      }
      var tkAtc = card.querySelector('.tk-card-atc');
      if (tkAtc && !rightTarget.contains(tkAtc)) {
        rightTarget.appendChild(tkAtc);
      }

      /* Native swatches block (<product-swatches>) je defaultně rendrován jako
         sibling AFTER price block → po wrap kolem price by zůstal pod bottom-row.
         Per user request: swatches NAD cenu/skladem/ATC. Přesuneme je před
         bottom-row v rodiči. (Pro Globo karty `.tk-card-swatches` už je v Liquidu
         emitnut nad bottom-row, tak na něj neřešíme.) */
      var nativeSwatches = card.querySelector('product-swatches');
      if (nativeSwatches && existingRow.parentNode) {
        var afterRow = existingRow.nextElementSibling === nativeSwatches;
        if (afterRow || !existingRow.parentNode.contains(nativeSwatches) || existingRow.compareDocumentPosition(nativeSwatches) & Node.DOCUMENT_POSITION_FOLLOWING) {
          var swAnchor = swatchAnchor(card) || existingRow;
          swAnchor.parentNode.insertBefore(nativeSwatches, swAnchor);
        }
      }

      card.setAttribute('data-tk-atc-relocated', '1');
    });
  }

  /* (Předchozí JS strip slot="overflow" + MutationObserver odstraněn — rozbíjelo
     click event chain na swatches. Místo toho zmenšen column-gap v CSS aby se
     všechny 4 swatche přirozeně vešly do container width.) */

  /* Image retry pro karty — pokud product-card img zůstane neloaděný (broken src
     z CDN flake, nebo `loading="lazy"` v horizontálním carouselu kde IO neztrigne
     spolehlivě), JS to chytí a vynutí reload. Symptom: user vidí kartu jen s
     titulem bez obrázku, refresh page to fixne. Strategy:
     1) `error` event → retry src jednou po 400ms
     2) IntersectionObserver na card-gallery → když karta vstoupí do viewportu, force
        eager load všech jejích `img.product-media__image`
     3) Delayed sweep 2.5s po DOM ready: jakýkoliv lazy img co je still
        not-complete → switch na eager + force reload.
     Idempotent přes `_tkImgRetryHooked` flag na img elementu. */
  function ensureImgRetry(img) {
    if (!img || img._tkImgRetryHooked) return;
    img._tkImgRetryHooked = true;

    /* Plynulý fade-in místo „popnutí" z bílé. JEN pro obrázky, co se teprve
       načítají (necachované — typicky čerstvé Globo karty po filtru). Hotové/
       cached necháme být (zůstanou viditelné → žádné riziko neviditelného
       obrázku). Pojistka: odhal po 1,2 s, kdyby load/error nezafiroval. */
    if (!img.complete || img.naturalWidth === 0) {
      img.classList.add('tk-img-fade');
      var reveal = function () { img.classList.add('tk-img-in'); };
      img.addEventListener('load', reveal, { once: true });
      img.addEventListener('error', reveal, { once: true });
      setTimeout(reveal, 1200);
    }

    img.addEventListener('error', function () {
      if (img._tkImgRetried) return;
      img._tkImgRetried = true;
      var origSrc = img.getAttribute('src');
      if (!origSrc) return;
      setTimeout(function () {
        img.removeAttribute('src');
        void img.offsetWidth; /* reflow */
        img.setAttribute('src', origSrc);
      }, 400);
    });
  }

  function forceLoadCardImages(card) {
    if (!card) return;
    card.querySelectorAll('img.product-media__image').forEach(function (img) {
      ensureImgRetry(img);
      if (img.complete && img.naturalWidth > 0) return; /* already loaded */
      if (img.loading === 'lazy') img.loading = 'eager';
      /* Pokud src je set ale browser ho z lazy stavu nesepnul, force reload přes re-assign */
      var src = img.getAttribute('src');
      if (src && (!img.complete || img.naturalWidth === 0)) {
        /* Jen pokud img dosud opravdu nezačala loadovat — nereassign během valid in-flight load */
        if (!img._tkImgForceTried) {
          img._tkImgForceTried = true;
          img.removeAttribute('src');
          void img.offsetWidth;
          img.setAttribute('src', src);
        }
      }
    });
  }

  var tkImgIO = null;
  function getImgIO() {
    if (tkImgIO) return tkImgIO;
    if (typeof IntersectionObserver === 'undefined') return null;
    tkImgIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          forceLoadCardImages(entry.target);
          tkImgIO.unobserve(entry.target);
        }
      });
    }, { rootMargin: '300px' });
    return tkImgIO;
  }

  function initImageRetry() {
    var io = getImgIO();
    document.querySelectorAll('product-card').forEach(function (card) {
      if (card._tkImgRetryQueued) return;
      card._tkImgRetryQueued = true;
      /* Setup error retry hooks immediately */
      card.querySelectorAll('img.product-media__image').forEach(ensureImgRetry);
      /* Observe pro force-load on enter viewport */
      if (io) io.observe(card);
      else forceLoadCardImages(card);
    });

    /* Force eager + reload sweep — horizontal carousel cards mohou být off-screen
       (vpravo mimo viewport), IO je nezachytí. Spustíme dvakrát: hned (300ms po
       initAll aby DOM stabilizoval) + 1.5s jako safety net. Jednorázové per
       window flag. */
    if (window.__tkImgSweepDone) return;
    window.__tkImgSweepDone = true;
    function sweep() {
      document.querySelectorAll('product-card img.product-media__image').forEach(function (img) {
        if (img.complete && img.naturalWidth > 0) return;
        if (img.loading === 'lazy') img.loading = 'eager';
        var src = img.getAttribute('src');
        if (src && !img._tkImgForceTried) {
          img._tkImgForceTried = true;
          img.removeAttribute('src');
          void img.offsetWidth;
          img.setAttribute('src', src);
        }
      });
    }
    setTimeout(sweep, 300);
    setTimeout(sweep, 1500);
  }

  /* Featured collection carousels: posun "Není skladem" karty na konec tracku,
     aby zabíraly místo až za skladovými. Reaguje na data-tk-available="false"
     na <product-card>. Per-track idempotent (data-tk-soldout-reordered).
     ⚠️ Řazení skladem-první teď dělá už Liquid (sections/product-list.liquid) —
     tohle je jen POJISTKA. Když je track už seřazený, NIC nepřesouváme: pozdní
     appendChild by přes `scroll-snap-type: x mandatory` vyvolal re-snap a
     carousel by skočil na hranici první přesunuté karty (bug „posun doprostřed").*/
  function reorderSoldOutToEnd() {
    document.querySelectorAll('.tk-product-carousel__track').forEach(function (track) {
      if (track.getAttribute('data-tk-soldout-reordered') === '1') return;
      var items = Array.prototype.slice.call(track.querySelectorAll(':scope > .tk-product-carousel__item'));
      if (!items.length) return;
      var isSold = function (item) {
        var card = item.querySelector('product-card[data-tk-available]');
        return card && card.getAttribute('data-tk-available') === 'false';
      };
      var soldOut = items.filter(isSold);
      if (!soldOut.length) {
        track.setAttribute('data-tk-soldout-reordered', '1');
        return;
      }
      /* Už seřazeno? = žádná skladová karta nesmí být ZA neskladovou.
         Pokud ne, nepřesouvat (jinak zbytečný re-snap = skok carouselu). */
      var needsReorder = false, seenSold = false;
      for (var i = 0; i < items.length; i++) {
        if (isSold(items[i])) seenSold = true;
        else if (seenSold) { needsReorder = true; break; }
      }
      if (!needsReorder) {
        track.setAttribute('data-tk-soldout-reordered', '1');
        return;
      }
      soldOut.forEach(function (item) { track.appendChild(item); });
      track.setAttribute('data-tk-soldout-reordered', '1');
    });
  }

  /* Run after DOM ready and on dynamic content */
  function initAll() {
    ingestEmbeddedSwatchData();
    initVariantSwapFix();
    initBadgeUpdate();
    initSwatchClicks();
    initSwatchHover();
    initAtcClicks();
    stripSoldOutAddedSpan();
    injectStockBadge();
    relocateAtcButton();
    /* Pilulka jde do .product-badges overlaye (existuje od server renderu),
       na pořadí vůči relocateAtcButton() nezávisí. */
    injectFreeShipBadges();
    reorderSoldOutToEnd();
    initImageRetry();
    initSwatchImgFadeIn();
  }

  /* Server-side rendered swatch imgs (Globo Liquid emit z variant.image) potřebují
     `is-loaded` class pro CSS fade-in + dismiss shimmer. Hooknutí onload událostí
     na všechny existující .tk-card-swatch img bez .is-loaded class. Idempotent
     přes `_tkImgLoadHooked` flag. */
  function initSwatchImgFadeIn() {
    document.querySelectorAll('.tk-card-swatch img').forEach(function (img) {
      if (img._tkImgLoadHooked || img.classList.contains('is-loaded')) return;
      img._tkImgLoadHooked = true;
      if (img.complete && img.naturalWidth > 0) {
        img.classList.add('is-loaded');
        return;
      }
      img.addEventListener('load', function () { this.classList.add('is-loaded'); }, { once: true });
      img.addEventListener('error', function () { this.classList.add('is-loaded'); }, { once: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Re-run for dynamically loaded cards */
  var target = document.getElementById('ResultsList') || document.getElementById('MainContent');
  if (target) {
    var timer = null;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(initAll, 200);
    }).observe(target, { childList: true, subtree: true });

    /* ⚡ RYCHLÁ injekce swatchů — BEZ 200ms debounce. Globo po sort/filtru
       nahradí grid client-side (BEZ swatchů); debounced initAll výš čeká 200ms,
       takže swatche „naskakovaly" za kartami. Tenhle observer reaguje OKAMŽITĚ:
       pro každou novou kartu zavolá fetchVariantImagesOnce. Když má produkt
       teplou cache (z embedu tk-swatch-data-embed / dřívějšího fetche),
       applyVariantImages proběhne v microtasku PŘED vykreslením → swatche jsou
       v kartě hned (instantně). Necachované (>50) startují fetch dřív než
       debounce. `_tkImagesQueued` brání dvojí práci s debounced cestou. */
    var fastInject = function (node) {
      if (node.nodeType !== 1) return;
      var cards;
      if (node.matches && node.matches('product-card.product-card')) cards = [node];
      else if (node.querySelectorAll) cards = node.querySelectorAll('product-card.product-card');
      else return;
      for (var i = 0; i < cards.length; i++) {
        var card = cards[i];
        if (card._tkImagesQueued) continue;
        card._tkImagesQueued = true;
        /* Swatch placeholder (shimmer ghost) odstraněn na přání uživatele —
           nelíbil se. Reálné swatche se injektnou po fetchi tk-variant-images;
           do té doby je swatch slot prázdný (žádné barevné placeholder tečky). */
        fetchVariantImagesOnce(card);
      }
    };
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) fastInject(added[j]);
      }
    }).observe(target, { childList: true, subtree: true });
  }
})();

/* ---------------------------------------------------------------------------
   TK 2026-07-27 — nahřívání variant images na dohled karty.

   Proč: snippets/card-gallery.liquid renderoval variant images `loading="eager"`,
   aby klik na swatch přepnul obrázek instantně. Cena byla ~989 kB stažených hned
   u karet hluboko pod přehybem (homepage, mobil) a hero obrázek (61 kB, LCP prvek)
   se kvůli soupeření o pásmo přenášel 4,3 s.

   Teď se rendrují jako `lazy` a tenhle observer je přepne na `eager`, jakmile se
   karta přiblíží viewportu (800px předstih). Uživatel musí ke kartě nejdřív
   doscrollovat, takže než na swatch klikne, je obrázek dávno stažený.

   ⚠️ Nestačí je nechat jen `lazy`: variant slidy bývají `hidden` (display:none)
   a lazy obrázek uvnitř display:none prohlížeč nenačte VŮBEC, dokud se nezobrazí
   — swatch swap by pak čekal na síť, což je přesně ten problém, kvůli kterému
   se kdysi zavedl eager. Nastavení loading="eager" fetch spustí bez ohledu na
   viditelnost.
--------------------------------------------------------------------------- */
(function () {
  var SEL_CARD = 'product-card';
  var SEL_IMG = '[variant-image] img[loading="lazy"]';

  function warm(card) {
    if (card._tkVariantsWarmed) return;
    card._tkVariantsWarmed = true;
    var imgs = card.querySelectorAll(SEL_IMG);
    for (var i = 0; i < imgs.length; i++) imgs[i].loading = 'eager';
  }

  /* Bez IntersectionObserver nahřej rovnou = původní chování, žádná regrese. */
  if (typeof IntersectionObserver === 'undefined') {
    var all = document.querySelectorAll(SEL_CARD);
    for (var i = 0; i < all.length; i++) warm(all[i]);
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        io.unobserve(entries[i].target);
        warm(entries[i].target);
      }
    },
    /* Předstih na VŠECH stranách: product-list sekce jsou vodorovné carousely,
       takže sousední karty jsou mimo viewport do strany, ne dolů. S '800px 0px'
       se nahřály až v okamžiku swipnutí. */
    { rootMargin: '800px' }
  );

  function observe(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.matches && root.matches(SEL_CARD) && !root._tkVariantsObserved) {
      root._tkVariantsObserved = true;
      io.observe(root);
    }
    var cards = root.querySelectorAll(SEL_CARD);
    for (var i = 0; i < cards.length; i++) {
      if (cards[i]._tkVariantsObserved) continue;
      cards[i]._tkVariantsObserved = true;
      io.observe(cards[i]);
    }
  }

  function start() {
    observe(document.body);
    /* Karty přibývají i za běhu (Globo grid, section rendering, recommendations). */
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) observe(added[j]);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
